var _defs, _g, _g2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaveganteEstelar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 156.9 156.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#Degradado_sin_nombre_20-32);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#Degradado_sin_nombre_10-10);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#Degradado_sin_nombre_20-36);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#Degradado_sin_nombre_20-85);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#Degradado_sin_nombre_20-16);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#Degradado_sin_nombre_20-98);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#Degradado_sin_nombre_20-121);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#Degradado_sin_nombre_20-30);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#Degradado_sin_nombre_20-55);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#Degradado_sin_nombre_10-7);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#Degradado_sin_nombre_10-8);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#Degradado_sin_nombre_20-110);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#Degradado_sin_nombre_20-141);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#Degradado_sin_nombre_20-168);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#Degradado_sin_nombre_20-135);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#Degradado_sin_nombre_6);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#Degradado_sin_nombre_20-144);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#Degradado_sin_nombre_20-13);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#Degradado_sin_nombre_20-136);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#Degradado_sin_nombre_20-124);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#Degradado_sin_nombre_20-44);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#Degradado_sin_nombre_20-93);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#Degradado_sin_nombre_20-20);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#Degradado_sin_nombre_20-77);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#Degradado_sin_nombre_20-5);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#Degradado_sin_nombre_20-127);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#Degradado_sin_nombre_20-99);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#Degradado_sin_nombre_20-137);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#Degradado_sin_nombre_20-83);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#Degradado_sin_nombre_20-128);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: url(#Degradado_sin_nombre_10-3);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#Degradado_sin_nombre_20-157);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#Degradado_sin_nombre_20-156);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#Degradado_sin_nombre_20-122);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#Degradado_sin_nombre_20-101);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#Degradado_sin_nombre_20-57);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#Degradado_sin_nombre_20-26);\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: url(#Degradado_sin_nombre_20-18);\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: url(#Degradado_sin_nombre_20-100);\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: url(#Degradado_sin_nombre_20-19);\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: url(#Degradado_sin_nombre_20-60);\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: url(#Degradado_sin_nombre_20-86);\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: url(#Degradado_sin_nombre_20-61);\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: url(#Degradado_sin_nombre_20-126);\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: url(#Degradado_sin_nombre_20-31);\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: url(#Degradado_sin_nombre_20-151);\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: url(#Degradado_sin_nombre_20-169);\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: url(#Degradado_sin_nombre_20-2);\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: url(#Degradado_sin_nombre_20-3);\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: url(#Degradado_sin_nombre_20-79);\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: url(#Degradado_sin_nombre_20-17);\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: url(#Degradado_sin_nombre_20-92);\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: url(#Degradado_sin_nombre_20-59);\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: url(#Degradado_sin_nombre_20-75);\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: url(#Degradado_sin_nombre_20-178);\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: url(#Degradado_sin_nombre_20-71);\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: url(#Degradado_sin_nombre_10-4);\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: url(#Degradado_sin_nombre_20-64);\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: url(#Degradado_sin_nombre_20-138);\r\n      }\r\n\r\n      .cls-60 {\r\n        fill: url(#Degradado_sin_nombre_20-70);\r\n      }\r\n\r\n      .cls-61 {\r\n        fill: url(#Degradado_sin_nombre_20-54);\r\n      }\r\n\r\n      .cls-62 {\r\n        fill: url(#Degradado_sin_nombre_20-153);\r\n      }\r\n\r\n      .cls-63 {\r\n        fill: url(#Degradado_sin_nombre_20-142);\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: url(#Degradado_sin_nombre_10-2);\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: url(#Degradado_sin_nombre_20-40);\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: url(#Degradado_sin_nombre_20-109);\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: url(#Degradado_sin_nombre_20-51);\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: url(#Degradado_sin_nombre_20-132);\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: url(#Degradado_sin_nombre_20-145);\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: url(#Degradado_sin_nombre_20-46);\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: url(#Degradado_sin_nombre_20-108);\r\n      }\r\n\r\n      .cls-72 {\r\n        fill: url(#Degradado_sin_nombre_20-37);\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: url(#Degradado_sin_nombre_20-120);\r\n      }\r\n\r\n      .cls-74 {\r\n        fill: url(#Degradado_sin_nombre_20-48);\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: url(#Degradado_sin_nombre_20-8);\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: url(#Degradado_sin_nombre_20-158);\r\n      }\r\n\r\n      .cls-77 {\r\n        fill: url(#Degradado_sin_nombre_20-80);\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: url(#Degradado_sin_nombre_10);\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: url(#Degradado_sin_nombre_20-88);\r\n      }\r\n\r\n      .cls-80 {\r\n        fill: url(#Degradado_sin_nombre_20-43);\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: #957d64;\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: url(#Degradado_sin_nombre_20-33);\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: url(#Degradado_sin_nombre_20-21);\r\n      }\r\n\r\n      .cls-84 {\r\n        fill: url(#Degradado_sin_nombre_20-41);\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: url(#Degradado_sin_nombre_20-73);\r\n      }\r\n\r\n      .cls-86 {\r\n        fill: url(#Degradado_sin_nombre_20-12);\r\n      }\r\n\r\n      .cls-87 {\r\n        fill: url(#Degradado_sin_nombre_20-165);\r\n      }\r\n\r\n      .cls-88 {\r\n        fill: url(#Degradado_sin_nombre_20-87);\r\n      }\r\n\r\n      .cls-89 {\r\n        fill: url(#Degradado_sin_nombre_20-166);\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: url(#Degradado_sin_nombre_20-159);\r\n      }\r\n\r\n      .cls-91 {\r\n        fill: url(#Degradado_sin_nombre_20-154);\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: url(#Degradado_sin_nombre_20-129);\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: url(#Degradado_sin_nombre_20-117);\r\n      }\r\n\r\n      .cls-94 {\r\n        fill: url(#Degradado_sin_nombre_20-15);\r\n      }\r\n\r\n      .cls-95 {\r\n        fill: url(#Degradado_sin_nombre_20-74);\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: url(#Degradado_sin_nombre_20-174);\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: url(#Degradado_sin_nombre_20-155);\r\n      }\r\n\r\n      .cls-98 {\r\n        fill: url(#Degradado_sin_nombre_20-116);\r\n      }\r\n\r\n      .cls-99 {\r\n        fill: url(#Degradado_sin_nombre_20-139);\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: url(#Degradado_sin_nombre_20-140);\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: url(#Degradado_sin_nombre_20-81);\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: url(#Degradado_sin_nombre_20-42);\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: url(#Degradado_sin_nombre_20-111);\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: url(#Degradado_sin_nombre_20-35);\r\n      }\r\n\r\n      .cls-105 {\r\n        fill: url(#Degradado_sin_nombre_20-173);\r\n      }\r\n\r\n      .cls-106 {\r\n        fill: url(#Degradado_sin_nombre_20-103);\r\n      }\r\n\r\n      .cls-107 {\r\n        fill: url(#Degradado_sin_nombre_20-172);\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: url(#Degradado_sin_nombre_20-84);\r\n      }\r\n\r\n      .cls-109 {\r\n        fill: url(#Degradado_sin_nombre_20-66);\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: url(#Degradado_sin_nombre_20);\r\n      }\r\n\r\n      .cls-111 {\r\n        fill: url(#Degradado_sin_nombre_20-167);\r\n      }\r\n\r\n      .cls-112 {\r\n        fill: url(#Degradado_sin_nombre_20-22);\r\n      }\r\n\r\n      .cls-113 {\r\n        fill: url(#Degradado_sin_nombre_20-171);\r\n      }\r\n\r\n      .cls-114 {\r\n        fill: url(#Degradado_sin_nombre_20-123);\r\n      }\r\n\r\n      .cls-115 {\r\n        fill: url(#Degradado_sin_nombre_20-38);\r\n      }\r\n\r\n      .cls-116 {\r\n        fill: url(#Degradado_sin_nombre_20-52);\r\n      }\r\n\r\n      .cls-117 {\r\n        fill: url(#Degradado_sin_nombre_20-114);\r\n      }\r\n\r\n      .cls-118 {\r\n        fill: url(#Degradado_sin_nombre_20-160);\r\n      }\r\n\r\n      .cls-119 {\r\n        fill: #705e4b;\r\n      }\r\n\r\n      .cls-120 {\r\n        fill: url(#Degradado_sin_nombre_20-131);\r\n      }\r\n\r\n      .cls-121 {\r\n        fill: url(#Degradado_sin_nombre_20-102);\r\n      }\r\n\r\n      .cls-122 {\r\n        fill: url(#Degradado_sin_nombre_20-143);\r\n      }\r\n\r\n      .cls-123 {\r\n        fill: url(#Degradado_sin_nombre_20-95);\r\n      }\r\n\r\n      .cls-124 {\r\n        fill: url(#Degradado_sin_nombre_20-11);\r\n      }\r\n\r\n      .cls-125 {\r\n        fill: url(#Degradado_sin_nombre_20-58);\r\n      }\r\n\r\n      .cls-126 {\r\n        fill: url(#Degradado_sin_nombre_20-10);\r\n      }\r\n\r\n      .cls-127 {\r\n        fill: url(#Degradado_sin_nombre_10-5);\r\n      }\r\n\r\n      .cls-128 {\r\n        fill: url(#Degradado_sin_nombre_20-82);\r\n      }\r\n\r\n      .cls-129 {\r\n        fill: url(#Degradado_sin_nombre_20-177);\r\n      }\r\n\r\n      .cls-130 {\r\n        fill: url(#Degradado_sin_nombre_20-50);\r\n      }\r\n\r\n      .cls-131 {\r\n        fill: url(#Degradado_sin_nombre_20-130);\r\n      }\r\n\r\n      .cls-132 {\r\n        fill: url(#Degradado_sin_nombre_20-96);\r\n      }\r\n\r\n      .cls-133 {\r\n        fill: url(#Degradado_sin_nombre_20-65);\r\n      }\r\n\r\n      .cls-134 {\r\n        fill: url(#Degradado_sin_nombre_20-45);\r\n      }\r\n\r\n      .cls-135 {\r\n        fill: url(#Degradado_sin_nombre_20-162);\r\n      }\r\n\r\n      .cls-136 {\r\n        fill: url(#Degradado_sin_nombre_20-175);\r\n      }\r\n\r\n      .cls-137 {\r\n        fill: url(#Degradado_sin_nombre_20-176);\r\n      }\r\n\r\n      .cls-138 {\r\n        fill: url(#Degradado_sin_nombre_20-94);\r\n      }\r\n\r\n      .cls-139 {\r\n        fill: url(#Degradado_sin_nombre_20-113);\r\n      }\r\n\r\n      .cls-140 {\r\n        fill: url(#Degradado_sin_nombre_20-115);\r\n      }\r\n\r\n      .cls-141 {\r\n        fill: url(#Degradado_sin_nombre_20-163);\r\n      }\r\n\r\n      .cls-142 {\r\n        fill: url(#Degradado_sin_nombre_20-107);\r\n      }\r\n\r\n      .cls-143 {\r\n        fill: url(#Degradado_sin_nombre_20-63);\r\n      }\r\n\r\n      .cls-144 {\r\n        fill: url(#Degradado_sin_nombre_20-134);\r\n      }\r\n\r\n      .cls-145 {\r\n        fill: url(#Degradado_sin_nombre_20-4);\r\n      }\r\n\r\n      .cls-146 {\r\n        fill: url(#Degradado_sin_nombre_20-150);\r\n      }\r\n\r\n      .cls-147 {\r\n        fill: url(#Degradado_sin_nombre_20-39);\r\n      }\r\n\r\n      .cls-148 {\r\n        fill: url(#Degradado_sin_nombre_20-9);\r\n      }\r\n\r\n      .cls-149 {\r\n        fill: url(#Degradado_sin_nombre_20-67);\r\n      }\r\n\r\n      .cls-150 {\r\n        fill: url(#Degradado_sin_nombre_20-62);\r\n      }\r\n\r\n      .cls-151 {\r\n        fill: url(#Degradado_sin_nombre_20-76);\r\n      }\r\n\r\n      .cls-152 {\r\n        fill: url(#Degradado_sin_nombre_20-34);\r\n      }\r\n\r\n      .cls-153 {\r\n        fill: url(#Degradado_sin_nombre_20-118);\r\n      }\r\n\r\n      .cls-154 {\r\n        fill: url(#Degradado_sin_nombre_20-164);\r\n      }\r\n\r\n      .cls-155 {\r\n        fill: url(#Degradado_sin_nombre_20-106);\r\n      }\r\n\r\n      .cls-156 {\r\n        fill: url(#Degradado_sin_nombre_20-49);\r\n      }\r\n\r\n      .cls-157 {\r\n        fill: url(#Degradado_sin_nombre_20-24);\r\n      }\r\n\r\n      .cls-158 {\r\n        fill: url(#Degradado_sin_nombre_20-146);\r\n      }\r\n\r\n      .cls-159 {\r\n        fill: url(#Degradado_sin_nombre_20-119);\r\n      }\r\n\r\n      .cls-160 {\r\n        fill: url(#Degradado_sin_nombre_20-152);\r\n      }\r\n\r\n      .cls-161 {\r\n        fill: url(#Degradado_sin_nombre_20-23);\r\n      }\r\n\r\n      .cls-162 {\r\n        fill: url(#Degradado_sin_nombre_20-133);\r\n      }\r\n\r\n      .cls-163 {\r\n        fill: url(#Degradado_sin_nombre_20-14);\r\n      }\r\n\r\n      .cls-164 {\r\n        fill: url(#Degradado_sin_nombre_20-29);\r\n      }\r\n\r\n      .cls-165 {\r\n        fill: url(#Degradado_sin_nombre_20-28);\r\n      }\r\n\r\n      .cls-166 {\r\n        fill: url(#Degradado_sin_nombre_20-89);\r\n      }\r\n\r\n      .cls-167 {\r\n        fill: url(#Degradado_sin_nombre_20-147);\r\n      }\r\n\r\n      .cls-168 {\r\n        fill: url(#Degradado_sin_nombre_20-149);\r\n      }\r\n\r\n      .cls-169 {\r\n        fill: url(#Degradado_sin_nombre_20-7);\r\n      }\r\n\r\n      .cls-170 {\r\n        fill: url(#Degradado_sin_nombre_10-9);\r\n      }\r\n\r\n      .cls-171 {\r\n        fill: url(#Degradado_sin_nombre_20-161);\r\n      }\r\n\r\n      .cls-172 {\r\n        fill: url(#Degradado_sin_nombre_20-170);\r\n      }\r\n\r\n      .cls-173 {\r\n        fill: url(#Degradado_sin_nombre_20-27);\r\n      }\r\n\r\n      .cls-174 {\r\n        fill: url(#Degradado_sin_nombre_20-69);\r\n      }\r\n\r\n      .cls-175 {\r\n        fill: url(#Degradado_sin_nombre_20-56);\r\n      }\r\n\r\n      .cls-176 {\r\n        fill: url(#Degradado_sin_nombre_20-112);\r\n      }\r\n\r\n      .cls-177 {\r\n        fill: url(#Degradado_sin_nombre_20-97);\r\n      }\r\n\r\n      .cls-178 {\r\n        fill: url(#Degradado_sin_nombre_20-105);\r\n      }\r\n\r\n      .cls-179 {\r\n        fill: url(#Degradado_sin_nombre_20-6);\r\n      }\r\n\r\n      .cls-180 {\r\n        fill: url(#Degradado_sin_nombre_20-125);\r\n      }\r\n\r\n      .cls-181 {\r\n        fill: url(#Degradado_sin_nombre_20-78);\r\n      }\r\n\r\n      .cls-182 {\r\n        fill: url(#Degradado_sin_nombre_20-47);\r\n      }\r\n\r\n      .cls-183 {\r\n        fill: url(#Degradado_sin_nombre_10-6);\r\n      }\r\n\r\n      .cls-184 {\r\n        fill: url(#Degradado_sin_nombre_20-53);\r\n      }\r\n\r\n      .cls-185 {\r\n        fill: url(#Degradado_sin_nombre_20-72);\r\n      }\r\n\r\n      .cls-186 {\r\n        fill: url(#Degradado_sin_nombre_20-25);\r\n      }\r\n\r\n      .cls-187 {\r\n        fill: url(#Degradado_sin_nombre_20-104);\r\n      }\r\n\r\n      .cls-188 {\r\n        fill: url(#Degradado_sin_nombre_20-148);\r\n      }\r\n\r\n      .cls-189 {\r\n        fill: url(#Degradado_sin_nombre_20-91);\r\n      }\r\n\r\n      .cls-190 {\r\n        fill: url(#Degradado_sin_nombre_20-68);\r\n      }\r\n\r\n      .cls-191 {\r\n        fill: url(#Degradado_sin_nombre_20-90);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20",
    "data-name": "Degradado sin nombre 20",
    x1: 111.47,
    y1: 85.34,
    x2: 119.93,
    y2: 85.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d2d9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e0e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-2",
    "data-name": "Degradado sin nombre 20",
    x1: 111.47,
    y1: 85.79,
    x2: 119.93,
    y2: 85.79,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-3",
    "data-name": "Degradado sin nombre 20",
    x1: 110.71,
    y1: 88.64,
    x2: 118.69,
    y2: 88.64,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-4",
    "data-name": "Degradado sin nombre 20",
    x1: 118.32,
    y1: 91.74,
    x2: 118.69,
    y2: 91.74,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-5",
    "data-name": "Degradado sin nombre 20",
    x1: 110.72,
    y1: 88.4,
    x2: 115.17,
    y2: 88.4,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-6",
    "data-name": "Degradado sin nombre 20",
    x1: 110.53,
    y1: 89.57,
    x2: 113.11,
    y2: 89.57,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-7",
    "data-name": "Degradado sin nombre 20",
    x1: 111.78,
    y1: 81.54,
    x2: 120.67,
    y2: 81.54,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-8",
    "data-name": "Degradado sin nombre 20",
    x1: 111.79,
    y1: 81.84,
    x2: 120.67,
    y2: 81.84,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-9",
    "data-name": "Degradado sin nombre 20",
    x1: 108,
    y1: 97.04,
    x2: 114.86,
    y2: 97.04,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-10",
    "data-name": "Degradado sin nombre 20",
    x1: 108,
    y1: 97.25,
    x2: 114.82,
    y2: 97.25,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-11",
    "data-name": "Degradado sin nombre 20",
    x1: 106.05,
    y1: 100.07,
    x2: 112.29,
    y2: 100.07,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-12",
    "data-name": "Degradado sin nombre 20",
    x1: 111.7,
    y1: 104.07,
    x2: 112.18,
    y2: 104.07,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-13",
    "data-name": "Degradado sin nombre 20",
    x1: 106.05,
    y1: 99.09,
    x2: 109.08,
    y2: 99.09,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-14",
    "data-name": "Degradado sin nombre 20",
    x1: 105.21,
    y1: 99.86,
    x2: 107.36,
    y2: 99.86,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-15",
    "data-name": "Degradado sin nombre 20",
    x1: 113.14,
    y1: 91.82,
    x2: 118.64,
    y2: 91.82,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-16",
    "data-name": "Degradado sin nombre 20",
    x1: 113.14,
    y1: 91.82,
    x2: 118.64,
    y2: 91.82,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-17",
    "data-name": "Degradado sin nombre 20",
    x1: 109.52,
    y1: 93.48,
    x2: 116.96,
    y2: 93.48,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-18",
    "data-name": "Degradado sin nombre 20",
    x1: 109.53,
    y1: 93.69,
    x2: 116.94,
    y2: 93.69,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-19",
    "data-name": "Degradado sin nombre 20",
    x1: 101.15,
    y1: 106.68,
    x2: 106.06,
    y2: 106.68,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-20",
    "data-name": "Degradado sin nombre 20",
    x1: 101.15,
    y1: 106.74,
    x2: 105.77,
    y2: 106.74,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-21",
    "data-name": "Degradado sin nombre 20",
    x1: 98.21,
    y1: 109.03,
    x2: 102.43,
    y2: 109.03,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-22",
    "data-name": "Degradado sin nombre 20",
    x1: 101.5,
    y1: 113.59,
    x2: 102.03,
    y2: 113.59,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-23",
    "data-name": "Degradado sin nombre 20",
    x1: 98.22,
    y1: 107.53,
    x2: 99.68,
    y2: 107.53,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-24",
    "data-name": "Degradado sin nombre 20",
    x1: 96.99,
    y1: 107.73,
    x2: 98.48,
    y2: 107.73,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-25",
    "data-name": "Degradado sin nombre 20",
    x1: 107.38,
    y1: 102.98,
    x2: 111.97,
    y2: 102.98,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-26",
    "data-name": "Degradado sin nombre 20",
    x1: 107.38,
    y1: 102.98,
    x2: 111.97,
    y2: 102.98,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-27",
    "data-name": "Degradado sin nombre 20",
    x1: 103.71,
    y1: 103.84,
    x2: 109.28,
    y2: 103.84,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-28",
    "data-name": "Degradado sin nombre 20",
    x1: 103.71,
    y1: 103.94,
    x2: 109.09,
    y2: 103.94,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-29",
    "data-name": "Degradado sin nombre 20",
    x1: 90.57,
    y1: 113.25,
    x2: 95.09,
    y2: 113.25,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-30",
    "data-name": "Degradado sin nombre 20",
    x1: 90.57,
    y1: 113.25,
    x2: 93.77,
    y2: 113.25,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-31",
    "data-name": "Degradado sin nombre 20",
    x1: 87.44,
    y1: 114.56,
    x2: 91.46,
    y2: 114.56,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-32",
    "data-name": "Degradado sin nombre 20",
    x1: 88.78,
    y1: 119.23,
    x2: 89.31,
    y2: 119.23,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-33",
    "data-name": "Degradado sin nombre 20",
    x1: 87.44,
    y1: 112.79,
    x2: 89.7,
    y2: 112.79,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-34",
    "data-name": "Degradado sin nombre 20",
    x1: 86.77,
    y1: 112.41,
    x2: 87.63,
    y2: 112.41,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-35",
    "data-name": "Degradado sin nombre 20",
    x1: 98.5,
    y1: 111.57,
    x2: 101.68,
    y2: 111.57,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-36",
    "data-name": "Degradado sin nombre 20",
    x1: 98.5,
    y1: 111.57,
    x2: 101.68,
    y2: 111.57,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-37",
    "data-name": "Degradado sin nombre 20",
    x1: 94.59,
    y1: 111.5,
    x2: 98.57,
    y2: 111.5,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-38",
    "data-name": "Degradado sin nombre 20",
    x1: 94.59,
    y1: 111.51,
    x2: 97.93,
    y2: 111.51,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-39",
    "data-name": "Degradado sin nombre 20",
    x1: 77.4,
    y1: 116.02,
    x2: 83.88,
    y2: 116.02,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-40",
    "data-name": "Degradado sin nombre 20",
    x1: 77.4,
    y1: 116.02,
    x2: 82.55,
    y2: 116.02,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-41",
    "data-name": "Degradado sin nombre 20",
    x1: 74.92,
    y1: 116.05,
    x2: 79.97,
    y2: 116.05,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-42",
    "data-name": "Degradado sin nombre 20",
    x1: 74.92,
    y1: 120.37,
    x2: 75.41,
    y2: 120.37,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-43",
    "data-name": "Degradado sin nombre 20",
    x1: 86.26,
    y1: 116.64,
    x2: 88.86,
    y2: 116.64,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-44",
    "data-name": "Degradado sin nombre 20",
    x1: 86.26,
    y1: 116.64,
    x2: 88.86,
    y2: 116.64,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-45",
    "data-name": "Degradado sin nombre 20",
    x1: 81.76,
    y1: 115.56,
    x2: 87.43,
    y2: 115.56,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-46",
    "data-name": "Degradado sin nombre 20",
    x1: 81.76,
    y1: 115.56,
    x2: 86.09,
    y2: 115.56,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-47",
    "data-name": "Degradado sin nombre 20",
    x1: 64.15,
    y1: 114.75,
    x2: 72.28,
    y2: 114.75,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-48",
    "data-name": "Degradado sin nombre 20",
    x1: 64.15,
    y1: 114.75,
    x2: 71.52,
    y2: 114.75,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-49",
    "data-name": "Degradado sin nombre 20",
    x1: 61.35,
    y1: 113.43,
    x2: 68.54,
    y2: 113.43,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-50",
    "data-name": "Degradado sin nombre 20",
    x1: 61.35,
    y1: 117.01,
    x2: 61.83,
    y2: 117.01,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-51",
    "data-name": "Degradado sin nombre 20",
    x1: 62.82,
    y1: 111.7,
    x2: 67.94,
    y2: 111.7,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-52",
    "data-name": "Degradado sin nombre 20",
    x1: 63.7,
    y1: 110.51,
    x2: 64.88,
    y2: 110.51,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-53",
    "data-name": "Degradado sin nombre 20",
    x1: 72.9,
    y1: 117.64,
    x2: 75.4,
    y2: 117.64,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-54",
    "data-name": "Degradado sin nombre 20",
    x1: 72.9,
    y1: 117.64,
    x2: 75.4,
    y2: 117.64,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-55",
    "data-name": "Degradado sin nombre 20",
    x1: 68.38,
    y1: 115.61,
    x2: 75.62,
    y2: 115.61,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-56",
    "data-name": "Degradado sin nombre 20",
    x1: 68.38,
    y1: 115.61,
    x2: 75.08,
    y2: 115.61,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-57",
    "data-name": "Degradado sin nombre 20",
    x1: 52.26,
    y1: 109.53,
    x2: 61.58,
    y2: 109.53,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-58",
    "data-name": "Degradado sin nombre 20",
    x1: 52.26,
    y1: 109.48,
    x2: 61.26,
    y2: 109.48,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-59",
    "data-name": "Degradado sin nombre 20",
    x1: 49.64,
    y1: 106.99,
    x2: 58.4,
    y2: 106.99,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-60",
    "data-name": "Degradado sin nombre 20",
    x1: 49.64,
    y1: 109.45,
    x2: 50.07,
    y2: 109.45,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-61",
    "data-name": "Degradado sin nombre 20",
    x1: 52.12,
    y1: 105.44,
    x2: 58.19,
    y2: 105.44,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-62",
    "data-name": "Degradado sin nombre 20",
    x1: 59.95,
    y1: 114.45,
    x2: 63.69,
    y2: 114.45,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-63",
    "data-name": "Degradado sin nombre 20",
    x1: 59.95,
    y1: 114.45,
    x2: 63.69,
    y2: 114.45,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-64",
    "data-name": "Degradado sin nombre 20",
    x1: 55.89,
    y1: 111.63,
    x2: 64.8,
    y2: 111.63,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-65",
    "data-name": "Degradado sin nombre 20",
    x1: 55.89,
    y1: 111.61,
    x2: 64.44,
    y2: 111.61,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-66",
    "data-name": "Degradado sin nombre 20",
    x1: 43.01,
    y1: 100.93,
    x2: 52.92,
    y2: 100.93,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-67",
    "data-name": "Degradado sin nombre 20",
    x1: 43.01,
    y1: 100.74,
    x2: 52.85,
    y2: 100.74,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-68",
    "data-name": "Degradado sin nombre 20",
    x1: 41.04,
    y1: 97.46,
    x2: 50.64,
    y2: 97.46,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-69",
    "data-name": "Degradado sin nombre 20",
    x1: 41.04,
    y1: 98.52,
    x2: 41.37,
    y2: 98.52,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-70",
    "data-name": "Degradado sin nombre 20",
    x1: 44.26,
    y1: 96.23,
    x2: 50.61,
    y2: 96.23,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-71",
    "data-name": "Degradado sin nombre 20",
    x1: 46.17,
    y1: 94.98,
    x2: 48.57,
    y2: 94.98,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-72",
    "data-name": "Degradado sin nombre 20",
    x1: 48.81,
    y1: 107.31,
    x2: 53.58,
    y2: 107.31,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-73",
    "data-name": "Degradado sin nombre 20",
    x1: 48.81,
    y1: 107.31,
    x2: 53.58,
    y2: 107.31,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-74",
    "data-name": "Degradado sin nombre 20",
    x1: 45.66,
    y1: 104.05,
    x2: 55.45,
    y2: 104.05,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-75",
    "data-name": "Degradado sin nombre 20",
    x1: 45.66,
    y1: 103.92,
    x2: 55.32,
    y2: 103.92,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-76",
    "data-name": "Degradado sin nombre 20",
    x1: 37.38,
    y1: 89.63,
    x2: 47.21,
    y2: 89.63,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-77",
    "data-name": "Degradado sin nombre 20",
    x1: 37.37,
    y1: 88.72,
    x2: 47.21,
    y2: 88.72,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-78",
    "data-name": "Degradado sin nombre 20",
    x1: 36.5,
    y1: 86.31,
    x2: 46.07,
    y2: 86.31,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-79",
    "data-name": "Degradado sin nombre 20",
    x1: 36.5,
    y1: 85.37,
    x2: 36.83,
    y2: 85.37,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-80",
    "data-name": "Degradado sin nombre 20",
    x1: 40.11,
    y1: 85.51,
    x2: 46.07,
    y2: 85.51,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-81",
    "data-name": "Degradado sin nombre 20",
    x1: 42.26,
    y1: 84.14,
    x2: 44.96,
    y2: 84.14,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-82",
    "data-name": "Degradado sin nombre 20",
    x1: 40.68,
    y1: 96.92,
    x2: 46.15,
    y2: 96.92,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-83",
    "data-name": "Degradado sin nombre 20",
    x1: 40.68,
    y1: 96.92,
    x2: 46.15,
    y2: 96.92,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-84",
    "data-name": "Degradado sin nombre 20",
    x1: 38.76,
    y1: 93.45,
    x2: 48.7,
    y2: 93.45,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-85",
    "data-name": "Degradado sin nombre 20",
    x1: 38.76,
    y1: 92.88,
    x2: 48.69,
    y2: 92.88,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-86",
    "data-name": "Degradado sin nombre 20",
    x1: 35.98,
    y1: 76.66,
    x2: 45.06,
    y2: 76.66,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-87",
    "data-name": "Degradado sin nombre 20",
    x1: 36.49,
    y1: 74,
    x2: 45.18,
    y2: 74,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-88",
    "data-name": "Degradado sin nombre 20",
    x1: 36.5,
    y1: 71.43,
    x2: 36.83,
    y2: 71.43,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-89",
    "data-name": "Degradado sin nombre 20",
    x1: 40.11,
    y1: 73.8,
    x2: 45.18,
    y2: 73.8,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-90",
    "data-name": "Degradado sin nombre 20",
    x1: 42.26,
    y1: 72.51,
    x2: 44.96,
    y2: 72.51,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-91",
    "data-name": "Degradado sin nombre 20",
    x1: 36.42,
    y1: 83.94,
    x2: 42.24,
    y2: 83.94,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-92",
    "data-name": "Degradado sin nombre 20",
    x1: 36.42,
    y1: 83.94,
    x2: 42.24,
    y2: 83.94,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-93",
    "data-name": "Degradado sin nombre 20",
    x1: 35.96,
    y1: 81.19,
    x2: 45.35,
    y2: 81.19,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-94",
    "data-name": "Degradado sin nombre 20",
    x1: 35.96,
    y1: 80.64,
    x2: 45.35,
    y2: 80.64,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-95",
    "data-name": "Degradado sin nombre 20",
    x1: 38.95,
    y1: 64.98,
    x2: 46.67,
    y2: 64.98,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-96",
    "data-name": "Degradado sin nombre 20",
    x1: 38.95,
    y1: 64.67,
    x2: 46.67,
    y2: 64.67,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-97",
    "data-name": "Degradado sin nombre 20",
    x1: 40.88,
    y1: 61.76,
    x2: 48.04,
    y2: 61.76,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-98",
    "data-name": "Degradado sin nombre 20",
    x1: 40.91,
    y1: 58.18,
    x2: 41.34,
    y2: 58.18,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-99",
    "data-name": "Degradado sin nombre 20",
    x1: 44.26,
    y1: 62.39,
    x2: 48.04,
    y2: 62.39,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-100",
    "data-name": "Degradado sin nombre 20",
    x1: 46.17,
    y1: 61.4,
    x2: 48.57,
    y2: 61.4,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-101",
    "data-name": "Degradado sin nombre 20",
    x1: 36.5,
    y1: 70.73,
    x2: 42.24,
    y2: 70.73,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-102",
    "data-name": "Degradado sin nombre 20",
    x1: 36.5,
    y1: 70.73,
    x2: 42.24,
    y2: 70.73,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-103",
    "data-name": "Degradado sin nombre 20",
    x1: 37.51,
    y1: 68.73,
    x2: 45.74,
    y2: 68.73,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-104",
    "data-name": "Degradado sin nombre 20",
    x1: 37.52,
    y1: 68.48,
    x2: 45.73,
    y2: 68.48,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-105",
    "data-name": "Degradado sin nombre 20",
    x1: 45.98,
    y1: 54.17,
    x2: 51.9,
    y2: 54.17,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-106",
    "data-name": "Degradado sin nombre 20",
    x1: 46.13,
    y1: 54.05,
    x2: 51.9,
    y2: 54.05,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-107",
    "data-name": "Degradado sin nombre 20",
    x1: 49.13,
    y1: 51.43,
    x2: 54.37,
    y2: 51.43,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-108",
    "data-name": "Degradado sin nombre 20",
    x1: 49.36,
    y1: 47.11,
    x2: 49.87,
    y2: 47.11,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-109",
    "data-name": "Degradado sin nombre 20",
    x1: 52.12,
    y1: 52.7,
    x2: 54.37,
    y2: 52.7,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-110",
    "data-name": "Degradado sin nombre 20",
    x1: 41.04,
    y1: 58.7,
    x2: 46.15,
    y2: 58.7,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-111",
    "data-name": "Degradado sin nombre 20",
    x1: 41.04,
    y1: 58.7,
    x2: 46.15,
    y2: 58.7,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-112",
    "data-name": "Degradado sin nombre 20",
    x1: 43.29,
    y1: 57.43,
    x2: 49.83,
    y2: 57.43,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-113",
    "data-name": "Degradado sin nombre 20",
    x1: 43.36,
    y1: 57.28,
    x2: 49.83,
    y2: 57.28,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-114",
    "data-name": "Degradado sin nombre 20",
    x1: 56.32,
    y1: 45.95,
    x2: 60.19,
    y2: 45.95,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-115",
    "data-name": "Degradado sin nombre 20",
    x1: 56.79,
    y1: 45.94,
    x2: 60.19,
    y2: 45.94,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-116",
    "data-name": "Degradado sin nombre 20",
    x1: 60.03,
    y1: 44.08,
    x2: 63.69,
    y2: 44.08,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-117",
    "data-name": "Degradado sin nombre 20",
    x1: 60.95,
    y1: 39.4,
    x2: 61.49,
    y2: 39.4,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-118",
    "data-name": "Degradado sin nombre 20",
    x1: 62.13,
    y1: 45.76,
    x2: 63.69,
    y2: 45.76,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-119",
    "data-name": "Degradado sin nombre 20",
    x1: 63.64,
    y1: 45.85,
    x2: 64.8,
    y2: 45.85,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-120",
    "data-name": "Degradado sin nombre 20",
    x1: 49.64,
    y1: 48.7,
    x2: 53.58,
    y2: 48.7,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-121",
    "data-name": "Degradado sin nombre 20",
    x1: 49.64,
    y1: 48.7,
    x2: 53.58,
    y2: 48.7,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-122",
    "data-name": "Degradado sin nombre 20",
    x1: 52.66,
    y1: 48.28,
    x2: 57.2,
    y2: 48.28,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-123",
    "data-name": "Degradado sin nombre 20",
    x1: 53,
    y1: 48.24,
    x2: 57.21,
    y2: 48.24,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-124",
    "data-name": "Degradado sin nombre 20",
    x1: 67.25,
    y1: 41.22,
    x2: 72.77,
    y2: 41.22,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-125",
    "data-name": "Degradado sin nombre 20",
    x1: 68.9,
    y1: 41.22,
    x2: 72.77,
    y2: 41.22,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-126",
    "data-name": "Degradado sin nombre 20",
    x1: 71.07,
    y1: 40.54,
    x2: 75.4,
    y2: 40.54,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-127",
    "data-name": "Degradado sin nombre 20",
    x1: 74.45,
    y1: 35.99,
    x2: 74.95,
    y2: 35.99,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-128",
    "data-name": "Degradado sin nombre 20",
    x1: 72.5,
    y1: 42.36,
    x2: 75.4,
    y2: 42.36,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-129",
    "data-name": "Degradado sin nombre 20",
    x1: 61.35,
    y1: 41.77,
    x2: 64.22,
    y2: 41.77,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-130",
    "data-name": "Degradado sin nombre 20",
    x1: 61.35,
    y1: 41.77,
    x2: 64.22,
    y2: 41.77,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-131",
    "data-name": "Degradado sin nombre 20",
    x1: 63.7,
    y1: 42.34,
    x2: 68.52,
    y2: 42.34,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-132",
    "data-name": "Degradado sin nombre 20",
    x1: 65.4,
    y1: 42.34,
    x2: 68.52,
    y2: 42.34,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-133",
    "data-name": "Degradado sin nombre 20",
    x1: 78.81,
    y1: 40.46,
    x2: 86.16,
    y2: 40.46,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-134",
    "data-name": "Degradado sin nombre 20",
    x1: 79.85,
    y1: 40.47,
    x2: 86.16,
    y2: 40.47,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-135",
    "data-name": "Degradado sin nombre 20",
    x1: 82.69,
    y1: 41.12,
    x2: 88.86,
    y2: 41.12,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-136",
    "data-name": "Degradado sin nombre 20",
    x1: 88.37,
    y1: 37.12,
    x2: 88.86,
    y2: 37.12,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-137",
    "data-name": "Degradado sin nombre 20",
    x1: 83.54,
    y1: 42.91,
    x2: 87.97,
    y2: 42.91,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-138",
    "data-name": "Degradado sin nombre 20",
    x1: 86.55,
    y1: 43.95,
    x2: 87.43,
    y2: 43.95,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-139",
    "data-name": "Degradado sin nombre 20",
    x1: 74.92,
    y1: 38.7,
    x2: 77.24,
    y2: 38.7,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-140",
    "data-name": "Degradado sin nombre 20",
    x1: 74.92,
    y1: 38.7,
    x2: 77.24,
    y2: 38.7,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-141",
    "data-name": "Degradado sin nombre 20",
    x1: 76.24,
    y1: 40.26,
    x2: 81.81,
    y2: 40.26,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-142",
    "data-name": "Degradado sin nombre 20",
    x1: 90.12,
    y1: 43.75,
    x2: 98.91,
    y2: 43.75,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-143",
    "data-name": "Degradado sin nombre 20",
    x1: 90.64,
    y1: 43.76,
    x2: 98.91,
    y2: 43.76,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-144",
    "data-name": "Degradado sin nombre 20",
    x1: 93.62,
    y1: 45.71,
    x2: 101.68,
    y2: 45.71,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-145",
    "data-name": "Degradado sin nombre 20",
    x1: 101.22,
    y1: 42.65,
    x2: 101.68,
    y2: 42.65,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-146",
    "data-name": "Degradado sin nombre 20",
    x1: 94.01,
    y1: 47.36,
    x2: 99.68,
    y2: 47.36,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-147",
    "data-name": "Degradado sin nombre 20",
    x1: 96.97,
    y1: 48.63,
    x2: 98.48,
    y2: 48.63,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-148",
    "data-name": "Degradado sin nombre 20",
    x1: 87.44,
    y1: 39.78,
    x2: 90.58,
    y2: 39.78,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-149",
    "data-name": "Degradado sin nombre 20",
    x1: 87.44,
    y1: 39.78,
    x2: 90.58,
    y2: 39.78,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-150",
    "data-name": "Degradado sin nombre 20",
    x1: 86.77,
    y1: 42.25,
    x2: 94.93,
    y2: 42.25,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-151",
    "data-name": "Degradado sin nombre 20",
    x1: 87.22,
    y1: 42.24,
    x2: 94.93,
    y2: 42.24,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-152",
    "data-name": "Degradado sin nombre 20",
    x1: 99.93,
    y1: 50.76,
    x2: 109.63,
    y2: 50.76,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-153",
    "data-name": "Degradado sin nombre 20",
    x1: 100.1,
    y1: 50.86,
    x2: 109.63,
    y2: 50.86,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-154",
    "data-name": "Degradado sin nombre 20",
    x1: 102.69,
    y1: 53.81,
    x2: 111.97,
    y2: 53.81,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-155",
    "data-name": "Degradado sin nombre 20",
    x1: 111.59,
    y1: 52.02,
    x2: 111.97,
    y2: 52.02,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-156",
    "data-name": "Degradado sin nombre 20",
    x1: 102.79,
    y1: 55.25,
    x2: 109.08,
    y2: 55.25,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-157",
    "data-name": "Degradado sin nombre 20",
    x1: 105.21,
    y1: 56.5,
    x2: 107.36,
    y2: 56.5,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-158",
    "data-name": "Degradado sin nombre 20",
    x1: 98.5,
    y1: 45.03,
    x2: 102.79,
    y2: 45.03,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-159",
    "data-name": "Degradado sin nombre 20",
    x1: 98.5,
    y1: 45.03,
    x2: 102.79,
    y2: 45.03,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-160",
    "data-name": "Degradado sin nombre 20",
    x1: 96.99,
    y1: 48.11,
    x2: 106.45,
    y2: 48.11,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-161",
    "data-name": "Degradado sin nombre 20",
    x1: 97.24,
    y1: 48.17,
    x2: 106.45,
    y2: 48.17,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-162",
    "data-name": "Degradado sin nombre 20",
    x1: 107.22,
    y1: 60.9,
    x2: 117.17,
    y2: 60.9,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-163",
    "data-name": "Degradado sin nombre 20",
    x1: 107.23,
    y1: 61.28,
    x2: 117.17,
    y2: 61.28,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-164",
    "data-name": "Degradado sin nombre 20",
    x1: 108.94,
    y1: 64.34,
    x2: 118.64,
    y2: 64.34,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-165",
    "data-name": "Degradado sin nombre 20",
    x1: 118.32,
    y1: 64.22,
    x2: 118.64,
    y2: 64.22,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-166",
    "data-name": "Degradado sin nombre 20",
    x1: 108.94,
    y1: 65.31,
    x2: 115.17,
    y2: 65.31,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-167",
    "data-name": "Degradado sin nombre 20",
    x1: 110.53,
    y1: 66.66,
    x2: 113.11,
    y2: 66.66,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-168",
    "data-name": "Degradado sin nombre 20",
    x1: 107.38,
    y1: 53.86,
    x2: 112.55,
    y2: 53.86,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-169",
    "data-name": "Degradado sin nombre 20",
    x1: 107.38,
    y1: 53.86,
    x2: 112.55,
    y2: 53.86,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-170",
    "data-name": "Degradado sin nombre 20",
    x1: 105.17,
    y1: 57.21,
    x2: 115.12,
    y2: 57.21,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-171",
    "data-name": "Degradado sin nombre 20",
    x1: 105.22,
    y1: 57.43,
    x2: 115.12,
    y2: 57.43,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-172",
    "data-name": "Degradado sin nombre 20",
    x1: 111.19,
    y1: 72.85,
    x2: 120.73,
    y2: 72.85,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-173",
    "data-name": "Degradado sin nombre 20",
    x1: 111.19,
    y1: 73.59,
    x2: 120.73,
    y2: 73.59,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-174",
    "data-name": "Degradado sin nombre 20",
    x1: 111.7,
    y1: 75.95,
    x2: 120.94,
    y2: 75.95,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-175",
    "data-name": "Degradado sin nombre 20",
    x1: 113.14,
    y1: 65.75,
    x2: 118.84,
    y2: 65.75,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-176",
    "data-name": "Degradado sin nombre 20",
    x1: 113.14,
    y1: 65.75,
    x2: 118.84,
    y2: 65.75,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-177",
    "data-name": "Degradado sin nombre 20",
    x1: 110.3,
    y1: 68.9,
    x2: 120.05,
    y2: 68.9,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-178",
    "data-name": "Degradado sin nombre 20",
    x1: 110.3,
    y1: 69.69,
    x2: 120.05,
    y2: 69.69,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    "data-name": "Degradado sin nombre 10",
    x1: 17.39,
    y1: 81.44,
    x2: 78.45,
    y2: 81.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff960b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-2",
    "data-name": "Degradado sin nombre 10",
    x1: 78.36,
    y1: 108.72,
    x2: 85.05,
    y2: 108.72,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-3",
    "data-name": "Degradado sin nombre 10",
    x1: 71.85,
    y1: 47.66,
    x2: 78.54,
    y2: 47.66,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-4",
    "data-name": "Degradado sin nombre 10",
    x1: 78.51,
    y1: 74.93,
    x2: 139.51,
    y2: 74.93,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-5",
    "data-name": "Degradado sin nombre 10",
    x1: 15.31,
    y1: 78.19,
    x2: 141.6,
    y2: 78.19,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-6",
    "data-name": "Degradado sin nombre 10",
    x1: 44.31,
    y1: 95.23,
    y2: 95.23,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-7",
    "data-name": "Degradado sin nombre 10",
    x1: 78.45,
    y1: 95.26,
    x2: 112.54,
    y2: 95.26,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-8",
    "data-name": "Degradado sin nombre 10",
    x1: 44.37,
    y1: 61.12,
    y2: 61.12,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-9",
    "data-name": "Degradado sin nombre 10",
    x1: 78.48,
    y1: 61.13,
    x2: 112.59,
    y2: 61.13,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10-10",
    "data-name": "Degradado sin nombre 10",
    x1: 43.1,
    y1: 78.19,
    x2: 113.8,
    y2: 78.19,
    xlinkHref: "#Degradado_sin_nombre_10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    "data-name": "Degradado sin nombre 6",
    x1: 74.1,
    y1: 78.19,
    x2: 82.8,
    y2: 78.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d1669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7251b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m119.38,88.63c.73-.81.75-2.12-.04-2.84,0,0-.29-.27-.74-.68-.45-.4-1.03-.92-1.66-1.42-.62-.5-1.24-.97-1.71-1.32-.47-.34-.78-.56-.78-.56-.85-.58-1.98-.39-2.61.3-.31.35-.43.77-.36,1.18.04.41.27.82.66,1.13,0,0,1.22.95,2.35,2,.57.53,1.14,1.08,1.56,1.5.41.43.68.71.68.71.7.76,1.89.8,2.65,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m119.38,88.63c.42-.46.6-1.09.54-1.67-.07.1-.14.21-.22.3-.73.83-1.91.82-2.65.09,0,0-.28-.28-.71-.69-.43-.41-.99-.94-1.6-1.45-.6-.51-1.2-.99-1.65-1.35-.45-.35-.76-.58-.76-.58-.35-.25-.58-.59-.68-.93-.2.33-.23.71-.16,1.07.07.36.29.71.64.99,0,0,1.22.95,2.35,2,.57.53,1.14,1.08,1.56,1.5.41.43.68.71.68.71.7.76,1.89.8,2.65,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m118.26,90.27s-1.05-1.24-2.14-2.35c-1.12-1.14-2.28-2.15-2.28-2.15-.75-.66-1.94-.61-2.63,0-.67.63-.67,1.61.05,2.33,0,0,.49.48.95.98.47.5.93,1.02.93,1.02l5.5,1.89c.13-.6.04-1.24-.38-1.71Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m118.44,91.77s-.08.07-.13.1l.32.11c.04-.16.06-.33.06-.49-.07.1-.16.19-.25.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m111.57,87c-.3-.29-.5-.64-.56-1-.44.62-.39,1.47.25,2.1,0,0,.49.48.95.98.47.5.93,1.02.93,1.02l2.04.7s-.22-.25-.54-.63c-.33-.37-.75-.86-1.21-1.33-.92-.96-1.85-1.83-1.85-1.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "m112.76,89.69c-.57-.63-1.51-.78-2.23-.49l2.58.89-.35-.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m120.66,79.45c.23-.39.32-.84.28-1.27h-5.81s.74.43,1.48.89c.74.46,1.48.96,1.48.96.86.58,2.02.37,2.57-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m120.66,79.45c.23-.39.32-.84.28-1.27h-.34c-.58.85-1.66,1.05-2.49.52l-.84-.52h-2.15s.74.43,1.48.89c.74.46,1.48.96,1.48.96.86.58,2.02.37,2.57-.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "m112.07,78.49c-.28.38-.35.81-.24,1.22.11.4.35.78.78,1.05,0,0,.32.21.81.52.49.32,1.13.76,1.74,1.22.62.46,1.24.95,1.71,1.32.47.38.76.64.76.64.77.67,1.97.6,2.63-.29.32-.44.45-.99.4-1.5-.06-.52-.33-1-.74-1.31,0,0-.29-.22-.73-.55-.44-.32-1.03-.74-1.65-1.14-1.22-.8-2.44-1.5-2.44-1.5h-2.73c-.11.09-.21.2-.3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m120.26,84.17c.37-.5.49-1.15.36-1.72-.05.11-.11.22-.19.32-.65.9-1.82,1.02-2.63.37,0,0-.31-.24-.77-.61-.46-.36-1.1-.82-1.75-1.27-.64-.44-1.29-.86-1.78-1.16-.49-.3-.83-.49-.83-.49-.37-.22-.63-.52-.77-.85-.16.35-.17.73-.04,1.09.12.35.36.68.74.91,0,0,.32.21.81.52.49.32,1.13.76,1.74,1.22.62.46,1.24.95,1.71,1.32.47.38.76.64.76.64.77.67,1.97.6,2.63-.29Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m113.76,101.36c.48-.26.84-.7,1.01-1.18.16-.5.13-1.04-.11-1.51,0,0-.73-1.42-1.58-2.77-.42-.67-.84-1.32-1.18-1.8-.34-.48-.57-.8-.57-.8-.6-.82-1.76-1.03-2.55-.57-.83.45-.99,1.44-.48,2.27,0,0,.2.33.51.81.3.49.7,1.17,1.06,1.85.37.68.72,1.39.98,1.92.26.54.42.9.42.9.4.94,1.53,1.38,2.5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m113.76,101.36c.55-.3.94-.82,1.06-1.4-.09.08-.19.16-.3.22-.97.54-2.08.15-2.54-.78,0,0-.68-1.42-1.49-2.77-.39-.68-.79-1.32-1.11-1.81-.32-.48-.54-.8-.54-.8-.24-.35-.35-.74-.32-1.09-.6.5-.68,1.36-.22,2.1,0,0,.2.33.51.81.3.49.7,1.17,1.06,1.85.37.68.72,1.39.98,1.92.26.54.42.9.42.9.4.94,1.53,1.38,2.5.86Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m112.16,102.55s-.15-.37-.38-.93c-.23-.55-.53-1.27-.89-1.99-.34-.72-.7-1.41-.98-1.92-.27-.51-.47-.85-.47-.85-.52-.89-1.62-1.21-2.49-.85-.43.18-.71.51-.84.91-.14.39-.11.85.12,1.3,0,0,.31.61.59,1.24.28.62.54,1.26.54,1.26l4.59,3.58c.16-.26.27-.55.31-.84.03-.3,0-.61-.12-.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m111.86,104.02c-.05.02-.1.04-.15.06l.27.21c.09-.14.16-.29.22-.44-.1.07-.21.13-.33.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m106.91,97.28c-.21-.38-.27-.78-.21-1.13-.63.44-.84,1.27-.45,2.06,0,0,.31.61.59,1.24.28.62.54,1.26.54,1.26l1.7,1.33s-.12-.31-.3-.77c-.18-.45-.44-1.07-.72-1.66-.27-.6-.56-1.18-.78-1.61-.22-.43-.37-.71-.37-.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m107.16,100.21c-.33-.78-1.17-1.23-1.95-1.19l2.15,1.68-.2-.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m117.97,93.1c.36-.29.57-.69.67-1.11l-5.5-1.89s.58.65,1.13,1.33c.54.67,1.07,1.38,1.07,1.38.62.83,1.78,1.01,2.63.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m117.97,93.1c.36-.29.57-.69.67-1.11l-.32-.11c-.8.63-1.88.46-2.51-.31l-.64-.77-2.04-.7s.58.65,1.13,1.33c.54.67,1.07,1.38,1.07,1.38.62.83,1.78,1.01,2.63.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m110.16,89.4c-.36.28-.59.65-.63,1.07-.04.41.11.87.41,1.25,0,0,.95,1.18,1.85,2.48.87,1.27,1.68,2.65,1.68,2.65.53.9,1.66,1.21,2.57.59.93-.61,1.18-1.91.61-2.77,0,0-.19-.3-.52-.76-.32-.45-.75-1.04-1.19-1.61-.86-1.14-1.83-2.21-1.83-2.21l-2.58-.89c-.13.05-.26.12-.37.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m116.04,97.44c.52-.35.85-.92.9-1.51-.08.09-.18.17-.28.25-.89.65-2.06.37-2.6-.5,0,0-.2-.33-.54-.83-.33-.5-.78-1.14-1.24-1.77-.45-.62-.93-1.23-1.31-1.68-.37-.44-.62-.74-.62-.74-.28-.32-.42-.69-.44-1.05-.55.55-.54,1.42,0,2.11,0,0,.95,1.18,1.85,2.48.87,1.27,1.68,2.65,1.68,2.65.53.9,1.66,1.21,2.57.59Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m104.32,111.57c.54-.09,1.02-.38,1.33-.8.31-.42.46-.94.38-1.46,0,0-.06-.39-.16-.98-.11-.6-.27-1.38-.44-2.15-.17-.77-.36-1.52-.53-2.09-.17-.56-.28-.93-.28-.93-.3-.96-1.33-1.54-2.23-1.36-.45.1-.82.34-1.02.7-.21.36-.27.83-.16,1.3,0,0,.37,1.48.62,3.03.25,1.52.41,3.12.41,3.12.09,1.02,1,1.8,2.08,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m104.32,111.57c.61-.11,1.16-.46,1.46-.99-.11.05-.23.08-.35.11-1.09.2-2.02-.54-2.14-1.56,0,0-.05-.39-.13-.97-.09-.59-.23-1.37-.38-2.13-.15-.76-.32-1.51-.47-2.07-.15-.56-.25-.93-.25-.93-.11-.41-.09-.81.05-1.14-.74.27-1.08,1.07-.89,1.91,0,0,.37,1.48.62,3.03.25,1.52.41,3.12.41,3.12.09,1.02,1,1.8,2.08,1.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m102.43,112.18s-.02-.4-.05-1c-.03-.59-.1-1.38-.2-2.18-.09-.79-.2-1.56-.3-2.13-.09-.57-.17-.96-.17-.96-.2-1-1.15-1.67-2.07-1.61-.47.03-.85.25-1.09.59-.25.33-.38.77-.31,1.27,0,0,.09.67.16,1.36.07.69.11,1.37.11,1.37l3.18,4.87c.49-.37.77-.97.74-1.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m101.66,113.48c-.06,0-.11,0-.16,0l.19.28c.13-.1.25-.22.35-.35-.12.03-.24.05-.37.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m99.16,105.49c-.07-.43,0-.82.17-1.13-.37.1-.67.34-.86.66-.2.31-.29.71-.23,1.15,0,0,.09.67.16,1.36.07.69.11,1.37.11,1.37l1.18,1.8s-.04-1.32-.18-2.63c-.07-.65-.15-1.3-.21-1.77-.08-.48-.12-.8-.12-.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m98.45,108.35c-.06-.85-.71-1.54-1.46-1.76l1.49,2.29-.03-.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "m110.98,105.13c.42-.17.76-.48.99-.84l-4.59-3.58s.33.8.64,1.62c.31.82.57,1.65.57,1.65.31.99,1.36,1.53,2.4,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m110.98,105.13c.42-.17.75-.48.99-.84l-.27-.21c-.97.32-1.94-.18-2.27-1.11l-.35-.93-1.7-1.33s.33.8.64,1.62c.31.82.57,1.65.57,1.65.31.99,1.36,1.53,2.4,1.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m104.79,99.09c-.87.28-1.31,1.16-.96,2.13,0,0,.51,1.42.93,2.94.22.76.39,1.51.53,2.09.13.58.21.97.21.97.21,1.02,1.18,1.68,2.25,1.39,1.08-.27,1.73-1.43,1.47-2.42,0,0-.39-1.44-.85-2.8-.22-.68-.48-1.36-.68-1.86-.2-.5-.33-.83-.33-.83l-2.15-1.68c-.14,0-.28.03-.42.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "m107.75,108.6c.61-.15,1.1-.6,1.34-1.14-.11.06-.22.11-.34.14-1.04.34-2.07-.32-2.29-1.31,0,0-.38-1.56-.84-3.03-.22-.73-.5-1.48-.7-2.02-.21-.54-.34-.89-.34-.89-.16-.4-.16-.79-.08-1.14-.68.37-.98,1.16-.67,2.01,0,0,.51,1.42.93,2.94.22.76.39,1.51.53,2.09.13.58.21.97.21.97.21,1.02,1.18,1.68,2.25,1.39Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "m92.07,118.18c1.09.21,2.18-.55,2.36-1.57,0,0,.08-.39.16-.99.09-.6.2-1.39.28-2.17.09-.77.14-1.56.17-2.15.03-.58.04-.97.04-.97.03-1.01-.76-1.89-1.67-2.02-.45-.05-.88.06-1.19.33-.32.27-.52.69-.57,1.18,0,0-.14,1.51-.39,3.06-.25,1.53-.63,3.08-.63,3.08-.25,1.01.36,2.02,1.44,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.07,118.18c.62.12,1.25-.07,1.7-.46-.12,0-.25,0-.37-.01-1.09-.14-1.74-1.17-1.52-2.16,0,0,.09-.38.19-.97.11-.59.23-1.36.34-2.13.11-.76.18-1.54.23-2.12.04-.57.07-.96.07-.96.02-.43.18-.78.42-1.06-.77.03-1.38.64-1.46,1.53,0,0-.14,1.51-.39,3.06-.25,1.53-.63,3.08-.63,3.08-.25,1.01.36,2.02,1.44,2.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m90.09,118.13s.47-1.53.8-3.09c.17-.77.32-1.53.41-2.11.09-.58.15-.97.15-.97.14-1-.55-1.96-1.43-2.18-.91-.26-1.71.34-1.93,1.3,0,0-.14.66-.3,1.33-.08.34-.17.67-.23.92-.07.25-.11.41-.11.41l1.42,5.64c.58-.21,1.04-.68,1.22-1.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.94,119.12c-.05-.01-.11-.03-.16-.05l.08.33c.16-.05.3-.13.44-.22-.12,0-.25-.02-.37-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m89.17,110.74c.07-.42.26-.77.53-1.01-.77-.06-1.43.5-1.62,1.35,0,0-.14.66-.3,1.33-.08.34-.17.67-.23.92-.07.25-.11.41-.11.41l.53,2.09s.1-.31.23-.8c.13-.48.3-1.12.45-1.76.31-1.26.52-2.55.52-2.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "m87.57,113.22c.21-.84-.17-1.69-.81-2.14l.67,2.65.14-.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m100.47,114.24c.45-.03.87-.2,1.21-.47l-3.18-4.87s.05.86.08,1.74c.03.88,0,1.75,0,1.75-.03,1.03.79,1.89,1.9,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m100.47,114.24c.45-.03.87-.2,1.21-.47l-.19-.28c-1.02,0-1.78-.8-1.79-1.79l-.03-.99-1.18-1.8s.05.86.08,1.74c.03.88,0,1.75,0,1.75-.03,1.03.79,1.89,1.9,1.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m96.56,106.52c-.92-.02-1.61.68-1.59,1.7,0,0,.01.39,0,.96,0,.57-.03,1.34-.07,2.13-.04.79-.11,1.56-.18,2.15-.07.59-.12.98-.12.98-.14,1.03.57,1.97,1.68,2.05,1.1.08,2.11-.78,2.18-1.82,0,0,.1-1.48.11-2.92,0-1.45-.09-2.87-.09-2.87l-1.49-2.29c-.14-.04-.28-.07-.42-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m96.29,116.48c.63.06,1.22-.22,1.64-.64-.12.02-.25.03-.37.02-1.1-.03-1.84-.95-1.74-1.98,0,0,.15-1.6.19-3.14.04-1.57-.04-3.09-.04-3.09-.02-.42.09-.81.29-1.11-.75.14-1.31.77-1.29,1.68,0,0,.01.39,0,.96,0,.57-.03,1.34-.07,2.13-.04.79-.11,1.56-.18,2.15-.07.59-.12.98-.12.98-.14,1.03.57,1.97,1.68,2.05Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m78.35,120.44c.96.51,2.23.21,2.74-.73,0,0,.79-1.41,1.45-2.83.67-1.45,1.22-2.88,1.22-2.88.36-.94-.1-2.03-.92-2.46-.82-.41-1.75-.06-2.17.85,0,0-.16.35-.4.88-.25.52-.6,1.2-.97,1.89-.74,1.39-1.6,2.71-1.6,2.71-.56.87-.32,2.02.65,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m78.35,120.44c.55.3,1.2.31,1.75.11-.12-.04-.23-.08-.34-.14-.98-.51-1.26-1.64-.73-2.54,0,0,.82-1.36,1.51-2.75.7-1.41,1.28-2.81,1.28-2.81.16-.39.43-.7.74-.88-.74-.2-1.51.15-1.88.97,0,0-.16.35-.4.88-.25.52-.6,1.2-.97,1.89-.74,1.39-1.6,2.71-1.6,2.71-.56.87-.32,2.02.65,2.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m76.48,119.75s.94-1.33,1.75-2.66c.41-.67.8-1.37,1.08-1.88.27-.51.45-.86.45-.86.46-.89.12-2.03-.65-2.54-.77-.49-1.74-.27-2.25.62,0,0-.09.15-.22.37-.14.22-.31.5-.49.79-.37.58-.76,1.15-.76,1.15l-.47,5.8c.61-.02,1.2-.27,1.56-.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m75.08,120.3s-.09-.06-.13-.1l-.03.34c.17,0,.33-.03.49-.07-.11-.05-.22-.11-.33-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m78.01,112.46c.21-.37.5-.63.83-.79-.71-.28-1.52-.02-1.98.76,0,0-.09.15-.22.37-.14.22-.31.5-.49.79-.37.58-.76,1.15-.76,1.15l-.18,2.15s.78-1.08,1.47-2.18c.7-1.12,1.32-2.25,1.32-2.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m75.7,114.28c.47-.71.39-1.66-.07-2.28l-.22,2.72.29-.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m87.57,119.44c.43.12.89.1,1.3-.04l-1.42-5.64s-.23.82-.5,1.66c-.26.83-.57,1.67-.57,1.67-.36.95.13,2.06,1.19,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m87.57,119.44c.43.12.89.1,1.3-.04l-.08-.33c-.97-.35-1.42-1.35-1.11-2.28l.3-.94-.53-2.09s-.23.82-.5,1.66c-.26.83-.57,1.67-.57,1.67-.36.95.13,2.06,1.19,2.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m86.39,110.88c-.44-.17-.87-.13-1.23.07-.37.18-.67.53-.83,1.01,0,0-.47,1.47-1.07,2.9-.3.72-.62,1.44-.87,1.98-.26.53-.43.88-.43.88-.47.92-.1,2.05.92,2.49,1.01.41,2.25-.03,2.65-1.02,0,0,.14-.34.35-.85.2-.51.47-1.17.7-1.87.48-1.38.85-2.74.85-2.74l-.67-2.65c-.12-.08-.24-.16-.38-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m82.88,120.2c.58.23,1.23.19,1.76-.07-.12-.02-.24-.06-.36-.1-1.03-.4-1.43-1.51-1-2.45,0,0,.16-.36.4-.9.23-.54.53-1.26.8-2,.27-.74.52-1.47.69-2.01.18-.54.28-.91.28-.91.12-.42.35-.74.64-.96-.38-.07-.75.03-1.06.22-.31.19-.57.52-.7.94,0,0-.47,1.47-1.07,2.9-.3.72-.62,1.44-.87,1.98-.26.53-.43.88-.43.88-.47.92-.1,2.05.92,2.49Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m64.63,118.12c.37.4.88.65,1.4.68.52.03,1.04-.13,1.43-.48,0,0,.29-.27.74-.67.44-.41,1.01-.98,1.56-1.55,1.1-1.12,2.08-2.33,2.08-2.33.64-.78.56-1.96-.08-2.61-.64-.69-1.64-.6-2.32.1,0,0-.27.28-.66.69-.4.41-.96.97-1.53,1.49-1.14,1.04-2.39,2.05-2.39,2.05-.81.63-.96,1.82-.22,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m64.63,118.12c.42.46,1.03.72,1.62.68-.1-.07-.2-.15-.28-.24-.76-.8-.66-1.99.13-2.65,0,0,.3-.26.74-.64.44-.4,1.02-.94,1.58-1.48,1.11-1.07,2.12-2.25,2.12-2.25.28-.32.63-.52.98-.58-.63-.47-1.48-.32-2.09.3,0,0-.27.28-.66.69-.4.41-.96.97-1.53,1.49-1.14,1.04-2.39,2.05-2.39,2.05-.81.63-.96,1.82-.22,2.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "m63.09,116.87s.32-.24.81-.59c.48-.35,1.11-.84,1.72-1.35.61-.51,1.19-1.02,1.62-1.41.43-.39.71-.67.71-.67.73-.72.77-1.87.21-2.61-.28-.38-.67-.57-1.09-.59-.41-.02-.85.11-1.23.43,0,0-.52.44-1.06.88-.54.44-1.09.84-1.09.84l-2.34,5.33c.58.2,1.24.11,1.74-.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "m61.58,116.94s-.06-.09-.09-.14l-.14.31c.16.05.32.09.48.1-.09-.08-.18-.18-.25-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m66.9,110.48c.32-.29.68-.45,1.04-.48-.29-.26-.65-.38-1.02-.36-.37,0-.75.14-1.09.43,0,0-.52.44-1.06.88-.54.44-1.09.84-1.09.84l-.87,1.97s.27-.19.67-.48c.4-.29.93-.7,1.44-1.11.51-.41,1.01-.83,1.37-1.15.36-.33.6-.54.6-.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "m64.12,111.45c.68-.51.91-1.43.68-2.18l-1.1,2.5.42-.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m73.68,120.17c.37.28.81.38,1.24.37l.47-5.8s-.48.72-1.01,1.42c-.52.69-1.07,1.38-1.07,1.38-.65.81-.54,1.98.36,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m73.68,120.17c.37.28.81.38,1.24.37l.03-.34c-.8-.62-.91-1.71-.32-2.5l.59-.81.18-2.15s-.48.72-1.01,1.42c-.52.69-1.07,1.38-1.07,1.38-.65.81-.54,1.98.36,2.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m75.33,111.68c-.71-.59-1.69-.44-2.3.36,0,0-.91,1.21-1.95,2.4-1.02,1.16-2.15,2.28-2.15,2.28-.74.74-.76,1.91.07,2.64.82.76,2.14.67,2.83-.09,0,0,.25-.26.6-.69.36-.42.83-.99,1.27-1.55.89-1.12,1.69-2.32,1.69-2.32l.22-2.72c-.08-.11-.18-.22-.29-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m69,119.37c.47.43,1.1.6,1.69.5-.11-.06-.21-.13-.31-.21-.85-.69-.87-1.9-.16-2.64,0,0,.27-.28.67-.73.4-.44.91-1.04,1.41-1.64.49-.59.96-1.21,1.31-1.68.34-.47.56-.78.56-.78.25-.35.57-.57.91-.68-.67-.39-1.51-.17-2.04.53,0,0-.91,1.21-1.95,2.4-1.02,1.16-2.15,2.28-2.15,2.28-.74.74-.76,1.91.07,2.64Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m52.41,111.47c.42,1.03,1.65,1.52,2.6,1.12,0,0,.37-.15.92-.4.55-.25,1.27-.59,1.97-.95.7-.35,1.39-.74,1.9-1.03.5-.3.84-.49.84-.49.86-.52,1.17-1.67.78-2.5-.2-.41-.53-.7-.93-.82-.4-.12-.87-.06-1.31.17,0,0-1.34.71-2.78,1.34-1.42.62-2.92,1.15-2.92,1.15-.98.35-1.5,1.4-1.06,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m52.41,111.47c.24.58.74,1.01,1.31,1.17-.07-.1-.14-.2-.19-.32-.47-.99.03-2.09.98-2.45,0,0,.37-.14.92-.37.55-.23,1.27-.55,1.97-.88.7-.32,1.39-.69,1.9-.97.5-.28.84-.47.84-.47.37-.22.75-.27,1.12-.23-.45-.63-1.29-.81-2.08-.39,0,0-1.34.71-2.78,1.34-1.42.62-2.92,1.15-2.92,1.15-.98.35-1.5,1.4-1.06,2.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m51.36,109.78s1.54-.45,3.02-1.02c.74-.28,1.45-.57,1.99-.81.53-.24.89-.41.89-.41.92-.43,1.35-1.53,1.04-2.39-.28-.9-1.22-1.25-2.14-.91,0,0-.63.25-1.28.48-.65.24-1.31.44-1.31.44l-3.94,4.28c.49.37,1.14.5,1.72.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m49.91,109.36c-.02-.05-.03-.11-.04-.16l-.23.25c.13.1.27.19.42.25-.06-.1-.12-.22-.15-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m57.05,104.98c.39-.17.79-.2,1.14-.11-.37-.68-1.2-.93-2.02-.62,0,0-.63.25-1.28.48-.65.24-1.31.44-1.31.44l-1.46,1.59s.31-.08.79-.24c.48-.15,1.11-.36,1.72-.58,1.23-.43,2.42-.96,2.42-.96Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m54.1,104.99c.82-.28,1.32-1.06,1.35-1.85l-1.85,2.01.5-.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "m60.3,116.35c.27.36.65.62,1.06.76l2.34-5.33s-.69.51-1.41,1.01c-.72.51-1.47.96-1.47.96-.88.54-1.15,1.7-.51,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "m60.3,116.35c.27.36.65.62,1.06.75l.14-.31c-.55-.86-.3-1.93.52-2.48l.82-.56.87-1.97s-.69.51-1.41,1.01c-.72.51-1.47.96-1.47.96-.88.54-1.15,1.7-.51,2.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m64.63,108.87c-.49-.78-1.45-.97-2.29-.41,0,0-.32.23-.8.53-.48.31-1.14.71-1.82,1.1-.68.4-1.37.76-1.9,1.02-.53.26-.89.44-.89.44-.94.45-1.34,1.55-.8,2.52.54.96,1.8,1.35,2.71.83,0,0,1.3-.72,2.5-1.5,1.22-.79,2.36-1.64,2.36-1.64l1.1-2.5c-.04-.14-.1-.27-.17-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m56.13,114.07c.3.56.86.9,1.43,1.02-.08-.09-.16-.19-.22-.3-.57-.94-.21-2.06.71-2.54,0,0,1.42-.74,2.73-1.55,1.34-.83,2.57-1.72,2.57-1.72.34-.24.73-.37,1.09-.36-.53-.55-1.36-.67-2.11-.16,0,0-.32.23-.8.53-.48.31-1.14.71-1.82,1.1-.68.4-1.37.76-1.9,1.02-.53.26-.89.44-.89.44-.94.45-1.34,1.55-.8,2.52Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m43.01,101.22c.06,1.11,1.07,1.97,2.1,1.9,0,0,1.62-.12,3.17-.34,1.57-.22,3.08-.56,3.08-.56.98-.21,1.64-1.2,1.55-2.12-.11-.91-.9-1.5-1.91-1.34,0,0-.38.06-.95.14-.57.07-1.34.16-2.12.23-.79.07-1.55.1-2.15.12-.59.01-.99.02-.99.02-1.04.01-1.87.84-1.79,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "m43.01,101.22c.03.63.38,1.19.86,1.53-.03-.12-.06-.24-.08-.36-.13-1.09.7-1.97,1.72-2,0,0,1.61-.07,3.14-.25.77-.08,1.55-.21,2.11-.31.57-.1.94-.17.94-.17.42-.08.81-.02,1.14.14-.24-.73-.95-1.19-1.84-1.04,0,0-.38.06-.95.14-.57.07-1.34.16-2.12.23-.79.07-1.55.1-2.15.12-.59.01-.99.02-.99.02-1.04.01-1.87.84-1.79,1.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "m42.56,99.29s.4.01.99.03c.61,0,1.41,0,2.19-.02.79-.02,1.56-.07,2.15-.12.58-.06.97-.09.97-.09,1-.11,1.77-1.01,1.77-1.93,0-.46-.17-.87-.49-1.14-.32-.27-.76-.43-1.25-.41,0,0-.68.03-1.36.04-.69.01-1.39,0-1.39,0l-5.11,2.77c.36.5.91.84,1.53.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "m41.33,98.42c0-.05,0-.11,0-.16l-.3.16c.09.14.21.26.33.37-.02-.12-.04-.24-.04-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m49.5,96.58c.43-.03.81.07,1.11.27-.12-.77-.84-1.27-1.71-1.24,0,0-.68.03-1.36.04-.69.01-1.39,0-1.39,0l-1.89,1.03s1.34.05,2.65.03c.65,0,1.3-.04,1.79-.07.49-.03.81-.06.81-.06Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m46.71,95.64c.86,0,1.6-.58,1.87-1.31l-2.4,1.3h.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "m48.89,108.39c.13.43.41.8.75,1.06l3.94-4.28s-.82.26-1.66.49c-.43.11-.85.23-1.17.31-.32.08-.53.13-.53.13-1,.22-1.65,1.24-1.32,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m48.89,108.39c.13.43.41.8.75,1.06l.23-.25c-.24-1,.35-1.93,1.3-2.18l.95-.26,1.46-1.59s-.82.26-1.66.49c-.43.11-.85.23-1.17.31-.32.08-.53.13-.53.13-1,.22-1.65,1.24-1.32,2.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m55.41,102.72c-.09-.46-.37-.79-.73-1-.36-.21-.82-.27-1.3-.14,0,0-.37.1-.94.25-.56.14-1.31.3-2.07.45-1.54.31-3.11.48-3.11.48-1.03.12-1.77,1.04-1.58,2.13.21,1.07,1.25,1.86,2.3,1.66,0,0,1.45-.26,2.85-.61,1.42-.36,2.76-.79,2.76-.79l1.85-2.01c0-.14,0-.29-.03-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m45.69,104.89c.11.62.52,1.13,1.02,1.43-.05-.11-.09-.23-.11-.36-.23-1.08.47-2.02,1.5-2.18,0,0,1.57-.23,3.09-.58,1.53-.35,2.98-.79,2.98-.79.41-.13.81-.12,1.15.01-.31-.7-1.08-1.07-1.94-.84,0,0-.37.1-.94.25-.56.14-1.31.3-2.07.45-1.54.31-3.11.48-3.11.48-1.03.12-1.77,1.04-1.58,2.13Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m37.44,88.47c-.27,1.06.35,2.22,1.38,2.48,0,0,1.56.42,3.1.71,1.57.3,3.09.47,3.09.47,1,.11,1.94-.6,2.16-1.5.2-.9-.37-1.71-1.36-1.89,0,0-.38-.07-.95-.18-.56-.11-1.31-.28-2.07-.47-.76-.19-1.53-.4-2.08-.58-.56-.18-.94-.3-.94-.3-.98-.33-2.04.19-2.33,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m37.44,88.47c-.17.61,0,1.24.32,1.73,0-.12.02-.25.05-.37.25-1.08,1.28-1.63,2.28-1.33,0,0,1.53.46,3.04.79,1.54.33,3.04.55,3.04.55.42.06.79.24,1.04.5,0-.76-.52-1.43-1.4-1.58,0,0-.38-.07-.95-.18-.56-.11-1.31-.28-2.07-.47-.76-.19-1.53-.4-2.08-.58-.56-.18-.94-.3-.94-.3-.98-.33-2.04.19-2.33,1.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m37.64,86.5s.38.14.94.35c.57.21,1.32.46,2.07.7.74.24,1.52.44,2.08.58.57.14.94.23.94.23.98.22,2-.38,2.3-1.25.29-.87-.17-1.74-1.15-2.02,0,0-.64-.19-1.29-.41-.65-.21-1.3-.45-1.3-.45l-5.74.95c.17.59.57,1.1,1.14,1.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m36.77,85.27c.02-.05.04-.1.06-.15l-.33.05c.05.16.11.31.19.46.02-.12.05-.24.09-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m45.09,86.2c.42.11.73.33.96.61.11-.76-.35-1.48-1.22-1.73,0,0-.64-.19-1.29-.41-.65-.21-1.3-.45-1.3-.45l-2.13.35s1.25.49,2.48.9c1.26.41,2.5.73,2.5.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m42.76,84.39c.81.28,1.7-.03,2.19-.62l-2.69.45.5.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m40.68,97.17c-.01.45.12.89.36,1.25l5.11-2.77s-.85-.02-1.73-.07c-.87-.05-1.76-.14-1.76-.14-1.02-.11-1.96.64-1.99,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.68,97.17c-.01.45.12.89.36,1.25l.3-.16c.1-1.03.96-1.71,1.94-1.64l.99.06,1.89-1.03s-.85-.02-1.73-.07c-.87-.05-1.76-.14-1.76-.14-1.02-.11-1.96.64-1.99,1.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m48.68,93.91c.06-.47-.08-.88-.37-1.18-.27-.31-.68-.52-1.18-.55,0,0-1.54-.09-3.07-.32-.77-.11-1.55-.24-2.14-.35-.58-.12-.96-.2-.96-.2-1.01-.23-2.01.41-2.19,1.5-.15,1.08.59,2.17,1.64,2.32,0,0,.36.05.91.13.54.07,1.25.16,1.99.22,1.45.12,2.86.15,2.86.15l2.4-1.3c.05-.13.09-.27.11-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m38.78,92.81c-.08.62.12,1.24.5,1.69,0-.12,0-.25.01-.37.14-1.1,1.11-1.76,2.13-1.57,0,0,.39.07.97.17.58.09,1.35.21,2.14.28.78.08,1.55.14,2.12.18.57.04.96.04.96.04.43.01.81.15,1.08.38-.02-.39-.2-.72-.48-.97-.26-.25-.64-.42-1.08-.45,0,0-1.54-.09-3.07-.32-.77-.11-1.55-.24-2.14-.35-.58-.12-.96-.2-.96-.2-1.01-.23-2.01.41-2.19,1.5Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m36.33,74.61c-.3.46-.41,1.01-.32,1.52.1.51.38.98.82,1.27,0,0,1.32.9,2.71,1.68.69.39,1.37.76,1.89,1.02.53.26.88.43.88.43.92.43,2.03.07,2.52-.72.52-.79.19-1.74-.66-2.23,0,0-.33-.19-.83-.47-.49-.29-1.18-.69-1.82-1.12-1.29-.85-2.57-1.81-2.57-1.81-.81-.63-2-.48-2.6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m36.33,74.61c-.34.52-.44,1.17-.26,1.74.04-.11.09-.23.16-.33.6-.94,1.76-1.12,2.6-.52,0,0,.32.22.81.56.49.33,1.16.76,1.82,1.16.67.41,1.33.79,1.84,1.06.51.27.86.45.86.45.38.19.66.48.81.81.29-.72-.05-1.52-.81-1.95,0,0-.33-.19-.83-.47-.49-.29-1.18-.69-1.82-1.12-1.29-.85-2.57-1.81-2.57-1.81-.81-.63-2-.48-2.6.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m37.17,72.81s.31.25.77.64c.46.38,1.09.86,1.74,1.33.64.46,1.29.9,1.77,1.22.48.32.82.52.82.52.88.53,2,.29,2.59-.44.29-.37.39-.79.3-1.2-.08-.41-.31-.8-.72-1.09,0,0-.56-.39-1.11-.81-.28-.21-.55-.42-.75-.58-.2-.16-.33-.27-.33-.27l-5.74-.95c-.06.61.2,1.23.66,1.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m36.73,71.37s.07-.08.11-.12l-.33-.05c-.01.17,0,.33.02.49.06-.11.13-.21.21-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m44.3,74.93c.36.24.61.55.72.89.18-.34.21-.72.1-1.08-.09-.36-.32-.69-.69-.95,0,0-.56-.39-1.11-.81-.28-.21-.55-.42-.75-.58-.2-.16-.33-.27-.33-.27l-2.13-.35s.25.21.63.53c.39.32.91.73,1.44,1.12.52.39,1.05.77,1.45,1.04.4.27.67.45.67.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "m42.67,72.47c.67.53,1.61.52,2.29.12l-2.69-.45.41.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "m36.56,83.87c-.17.42-.19.88-.06,1.3l5.74-.95s-.83-.29-1.62-.63c-.8-.33-1.6-.7-1.6-.7-.95-.44-2.05-.04-2.45.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m36.56,83.87c-.17.42-.19.88-.06,1.3l.33-.05c.4-.93,1.47-1.31,2.35-.92l.93.37,2.13-.35s-.83-.29-1.62-.63c-.8-.33-1.6-.7-1.6-.7-.95-.44-2.05-.04-2.45.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m45.18,83.41c.43-.84,0-1.75-.9-2.14,0,0-1.41-.59-2.81-1.3-1.37-.7-2.74-1.53-2.74-1.53-.9-.54-2.04-.27-2.54.71-.53.97-.14,2.24.79,2.72,0,0,.32.17.81.42.49.24,1.16.56,1.82.85.66.29,1.32.57,1.81.76.5.19.84.32.84.32l2.69-.45c.09-.11.17-.23.23-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m36.19,79.14c-.29.55-.32,1.21-.08,1.75.03-.12.07-.24.12-.35.48-.99,1.64-1.3,2.53-.79,0,0,.34.19.86.47.53.28,1.23.63,1.94.97,1.39.67,2.84,1.21,2.84,1.21.4.15.7.41.88.72.22-.75-.22-1.5-1.01-1.85,0,0-1.41-.59-2.81-1.3-1.37-.7-2.74-1.53-2.74-1.53-.9-.54-2.03-.27-2.54.71Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m39.77,61.13c-.9.66-1.07,1.98-.45,2.8,0,0,.99,1.29,2.02,2.47.51.59,1.07,1.17,1.47,1.59.41.41.68.69.68.69.72.7,1.9.72,2.62.14.7-.59.77-1.57.08-2.33,0,0-.26-.28-.63-.72-.37-.44-.87-1.03-1.35-1.65-.49-.62-.94-1.25-1.28-1.73-.33-.49-.56-.82-.56-.82-.58-.87-1.73-1.1-2.61-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m39.77,61.13c-.51.37-.78.97-.81,1.56.08-.09.17-.18.26-.26.84-.7,2.02-.49,2.61.35,0,0,.94,1.3,1.93,2.49.49.6,1.02,1.18,1.41,1.6.39.42.66.7.66.7.29.31.45.67.51,1.03.48-.6.47-1.44-.14-2.11,0,0-.26-.28-.63-.72-.37-.44-.87-1.03-1.35-1.65-.49-.62-.94-1.25-1.28-1.73-.33-.49-.56-.82-.56-.82-.58-.87-1.73-1.1-2.61-.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m41.14,59.69s.21.34.52.85c.32.51.76,1.18,1.22,1.83.45.65.91,1.27,1.28,1.74.36.46.61.76.61.76.64.78,1.81.93,2.58.43.38-.26.63-.62.69-1.03.06-.41-.06-.87-.34-1.27,0,0-.39-.55-.78-1.12-.38-.57-.76-1.16-.76-1.16l-5.11-2.77c-.23.57-.21,1.23.1,1.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m41.2,58.18s.09-.06.14-.08l-.3-.16c-.06.16-.11.32-.13.48.09-.08.18-.16.29-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m47.2,64.03c.26.34.38.72.38,1.07.58-.52.6-1.39.11-2.11,0,0-.39-.55-.78-1.12-.38-.57-.76-1.16-.76-1.16l-1.89-1.03s.69,1.16,1.42,2.24c.36.54.74,1.07,1.03,1.46.29.39.49.65.49.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m46.46,61.17c.47.72,1.36,1.03,2.11.85l-2.4-1.3.29.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.97,69.98c-.29.35-.44.78-.47,1.21l5.74.95s-.67-.54-1.33-1.12c-.67-.58-1.3-1.18-1.3-1.18-.73-.71-1.94-.7-2.64.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m36.97,69.98c-.29.35-.44.78-.47,1.21l.33.05c.7-.75,1.8-.77,2.53-.11l.75.65,2.13.35s-.67-.54-1.33-1.12c-.67-.58-1.3-1.18-1.3-1.18-.73-.71-1.94-.7-2.64.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m45.3,72.33c.64-.66.58-1.65-.17-2.32,0,0-.29-.26-.72-.65-.42-.39-.97-.93-1.51-1.49-.54-.56-1.09-1.15-1.46-1.59-.38-.45-.64-.75-.64-.75-.66-.8-1.83-.91-2.65-.16-.79.76-.87,2.07-.13,2.84,0,0,1.02,1.08,2.07,2.05,1.08.99,2.18,1.88,2.18,1.88l2.69.45c.12-.07.24-.16.34-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "m38.15,65.37c-.46.43-.66,1.05-.63,1.64.07-.1.15-.2.24-.29.78-.79,1.95-.71,2.64.06,0,0,1.06,1.19,2.17,2.27,1.14,1.09,2.3,2.06,2.3,2.06.32.27.54.62.62.97.41-.65.31-1.49-.36-2.08,0,0-.29-.26-.72-.65-.42-.39-.97-.93-1.51-1.49-.54-.56-1.09-1.15-1.46-1.59-.38-.45-.64-.75-.64-.75-.66-.8-1.83-.91-2.65-.16Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "m47.4,49.5c-1.04.35-1.66,1.51-1.32,2.51,0,0,.51,1.54,1.1,2.99.61,1.48,1.29,2.85,1.29,2.85.46.91,1.56,1.3,2.44.99.86-.33,1.23-1.25.84-2.17,0,0-.16-.36-.37-.89-.21-.53-.48-1.25-.73-1.99-.26-.74-.49-1.49-.65-2.06-.16-.57-.26-.95-.26-.95-.26-1-1.27-1.6-2.33-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "m47.4,49.5c-.61.19-1.04.67-1.27,1.21.11-.06.22-.12.34-.16,1.03-.38,2.06.18,2.36,1.18,0,0,.46,1.53,1.01,2.98.56,1.47,1.2,2.85,1.2,2.85.17.38.23.79.15,1.14.64-.41.91-1.21.56-2.04,0,0-.16-.36-.37-.89-.21-.53-.48-1.25-.73-1.99-.26-.74-.49-1.49-.65-2.06-.16-.57-.26-.95-.26-.95-.26-1-1.27-1.6-2.33-1.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "m49.16,48.59s.08.39.22.98c.14.59.34,1.36.55,2.12.21.75.46,1.51.65,2.06.2.55.33.92.33.92.35.94,1.41,1.47,2.31,1.24.44-.12.79-.39.98-.76.19-.37.23-.84.09-1.31,0,0-.19-.65-.37-1.31-.18-.66-.34-1.34-.34-1.34l-3.94-4.28c-.4.47-.6,1.09-.48,1.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m49.71,47.19c.05-.01.11-.02.16-.03l-.23-.25c-.11.13-.2.26-.28.41.11-.05.23-.1.35-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m53.49,54.66c.14.41.12.79.01,1.14.71-.32,1.04-1.11.78-1.96,0,0-.19-.65-.37-1.31-.18-.66-.34-1.34-.34-1.34l-1.46-1.59s.27,1.31.61,2.57c.16.62.36,1.26.51,1.72.15.46.25.77.25.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m53.72,51.72c.21.83.95,1.41,1.72,1.49l-1.85-2.01.13.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m41.89,56.96c-.39.23-.68.59-.85.98l5.11,2.77s-.45-.73-.88-1.49c-.43-.76-.84-1.55-.84-1.55-.47-.92-1.6-1.29-2.54-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m41.89,56.96c-.39.23-.68.59-.85.98l.3.16c.91-.47,1.96-.13,2.43.73l.49.86,1.89,1.03s-.45-.73-.88-1.49c-.43-.76-.84-1.55-.84-1.55-.47-.92-1.6-1.29-2.54-.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "m48.98,61.89c.42-.2.69-.55.79-.95.11-.4.06-.86-.18-1.29,0,0-.77-1.34-1.41-2.75-.33-.7-.64-1.43-.87-1.98-.21-.55-.36-.91-.36-.91-.36-.97-1.44-1.46-2.45-1.01-.99.47-1.5,1.67-1.04,2.64,0,0,.15.33.39.83.23.49.55,1.14.9,1.79.69,1.29,1.43,2.48,1.43,2.48l2.4,1.3c.14-.03.28-.07.41-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "m44.5,52.99c-.56.27-.97.78-1.14,1.34.1-.07.21-.14.32-.19,1-.49,2.08-.03,2.48.93,0,0,.16.36.39.91.24.54.57,1.24.93,1.94.36.7.73,1.37,1.01,1.87.28.5.49.83.49.83.22.37.31.76.27,1.12.31-.23.5-.56.55-.93.07-.36,0-.77-.21-1.15,0,0-.77-1.34-1.41-2.75-.33-.7-.64-1.43-.87-1.98-.21-.55-.36-.91-.36-.91-.36-.97-1.44-1.46-2.45-1.01Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "m58.39,40.97c-1.09,0-2.07.88-2.06,1.95,0,0,0,.4,0,1,0,.6.02,1.38.08,2.18.05.79.12,1.57.19,2.15.06.58.12.96.12.96.15,1.02,1.05,1.72,1.99,1.72.47,0,.85-.21,1.12-.53.27-.31.42-.75.38-1.25,0,0-.03-.39-.06-.96-.03-.58-.05-1.34-.05-2.12-.01-1.57.11-3.14.11-3.14.08-1.03-.68-1.93-1.8-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "m58.39,40.97c-.63,0-1.21.3-1.6.74.12-.02.24-.04.37-.04,1.1-.02,1.9.84,1.86,1.88,0,0-.01.4-.03.99,0,.6-.02,1.36.02,2.15.06,1.57.22,3.08.22,3.08.05.43-.04.82-.23,1.13.75-.18,1.25-.86,1.19-1.75,0,0-.03-.39-.06-.96-.03-.58-.05-1.34-.05-2.12-.01-1.57.11-3.14.11-3.14.08-1.03-.68-1.93-1.8-1.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m60.35,40.68s-.19,1.62-.27,3.18c-.04.78-.05,1.58-.05,2.16,0,.58,0,.97,0,.97.02,1,.86,1.84,1.78,1.93.91.06,1.65-.59,1.68-1.61,0,0,.03-.67.08-1.36.05-.68.12-1.37.12-1.37l-2.34-5.33c-.53.31-.92.83-1,1.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m61.33,39.54c.05,0,.11.01.16.02l-.14-.31c-.14.08-.28.18-.4.29.12-.01.25-.01.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m62.48,47.83c0,.42-.14.79-.35,1.09.76-.09,1.34-.71,1.37-1.61,0,0,.03-.67.08-1.36.05-.68.12-1.37.12-1.37l-.87-1.97s-.17,1.33-.26,2.62c-.08,1.32-.08,2.61-.08,2.61Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m63.65,45.13c-.07.85.45,1.64,1.15,1.97l-1.1-2.5-.05.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m50.76,46.25c-.44.1-.84.32-1.12.65l3.94,4.28s-.05-.21-.12-.53c-.06-.32-.15-.74-.23-1.16-.16-.85-.29-1.73-.29-1.73-.16-1.03-1.09-1.74-2.17-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m50.76,46.25c-.44.1-.84.32-1.12.65l.23.25c1.01-.16,1.89.51,2.06,1.47,0,0,.04.24.09.49.05.24.1.49.1.49l1.46,1.59s-.05-.21-.12-.53c-.06-.32-.15-.74-.23-1.16-.16-.85-.29-1.73-.29-1.73-.16-1.03-1.09-1.74-2.17-1.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m55.87,53.21c.93-.11,1.47-.96,1.3-1.93,0,0-.06-.38-.16-.95-.1-.58-.21-1.34-.28-2.11-.08-.77-.14-1.56-.18-2.15-.04-.6-.04-.99-.04-.99-.03-1.02-.9-1.86-1.99-1.74-.54.06-1.03.33-1.38.72-.34.39-.51.92-.47,1.43,0,0,.04.36.1.91.06.54.16,1.27.28,1.98.12.72.25,1.42.36,1.94.1.52.19.87.19.87l1.85,2.01c.14.02.28.01.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "m54.51,43.34c-.62.07-1.17.42-1.51.9.12-.04.24-.06.36-.08,1.1-.13,1.98.64,2.05,1.68,0,0,.03.39.08.98.05.58.14,1.37.25,2.14.11.77.24,1.53.35,2.09.12.57.2.95.2.95.09.42.04.82-.11,1.14.74-.24,1.14-1,1-1.86,0,0-.06-.38-.16-.95-.1-.58-.21-1.34-.28-2.11-.08-.77-.14-1.56-.18-2.15-.04-.6-.04-.99-.04-.99-.03-1.02-.9-1.86-1.99-1.74Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m71.56,36.48c-.52-.18-1.08-.14-1.55.06-.47.21-.86.61-1.03,1.1,0,0-.13.38-.33.94-.19.56-.43,1.33-.64,2.09-.21.76-.4,1.52-.53,2.08-.12.57-.2.96-.2.96-.19,1,.44,1.98,1.31,2.26.89.3,1.73-.24,2-1.19,0,0,.1-.37.25-.93.16-.56.39-1.3.64-2.03.25-.73.53-1.47.75-2.02.22-.56.38-.91.38-.91.41-.93-.02-2.06-1.06-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m71.56,36.48c-.59-.2-1.24-.13-1.75.17.12.01.24.04.36.08,1.05.35,1.52,1.43,1.14,2.39,0,0-.14.37-.35.92-.21.54-.46,1.3-.69,2.05-.23.75-.43,1.49-.58,2.04-.13.56-.22.94-.22.94-.09.42-.31.76-.58.98.39.05.75-.05,1.04-.28.3-.22.53-.55.65-.98,0,0,.1-.37.25-.93.16-.56.39-1.3.64-2.03.25-.73.53-1.47.75-2.02.22-.56.38-.91.38-.91.41-.93-.02-2.06-1.06-2.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m73.51,36.86s-.17.36-.43.91c-.25.55-.58,1.25-.87,2-.59,1.48-1.06,2.94-1.06,2.94-.3.98.21,2.01,1.06,2.41.43.2.86.17,1.24,0,.38-.16.7-.5.88-.97,0,0,.24-.64.51-1.28.27-.62.56-1.25.56-1.25l-.47-5.8c-.3.05-.59.17-.83.34-.24.18-.44.42-.58.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m74.81,36.09c.05.02.1.05.15.07l-.03-.34c-.16.03-.32.08-.47.14.12.03.24.07.35.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m73.19,44.29c-.14.41-.39.73-.69.93.75.16,1.5-.24,1.82-1.07,0,0,.24-.64.51-1.28.27-.62.56-1.25.56-1.25l-.18-2.15s-.14.3-.36.74c-.21.44-.48,1.05-.74,1.66-.51,1.22-.93,2.42-.93,2.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m75.18,42.12c-.35.77-.11,1.69.44,2.24l-.22-2.72-.22.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m62.62,38.99c-.45-.06-.9.04-1.27.26l2.34,5.33s.02-.22.06-.54c.03-.33.09-.76.15-1.18.12-.86.29-1.73.29-1.73.19-1.02-.47-2-1.56-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m62.62,38.99c-.45-.06-.9.04-1.27.26l.14.31c1,.16,1.63,1.09,1.47,2.05l-.13.99.87,1.97s.02-.22.06-.54c.03-.33.09-.76.15-1.18.12-.86.29-1.73.29-1.73.19-1.02-.47-2-1.56-2.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m65.2,47.23c.45.09.88,0,1.21-.26.33-.26.57-.66.64-1.14,0,0,.06-.38.15-.94.1-.56.24-1.34.42-2.09.34-1.5.81-3.04.81-3.04.31-.98-.24-2.05-1.31-2.29-.53-.12-1.09-.04-1.54.23-.45.27-.79.7-.91,1.2,0,0-.08.35-.21.89-.12.54-.26,1.26-.38,1.97-.12.71-.23,1.42-.29,1.95-.06.54-.1.89-.1.89l1.1,2.5c.13.06.26.11.4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m67.12,37.46c-.61-.13-1.25-.01-1.72.36.12,0,.25,0,.37.03,1.09.23,1.67,1.26,1.39,2.26,0,0-.1.38-.25.95-.14.58-.31,1.35-.46,2.12-.31,1.51-.47,3.05-.47,3.05-.05.43-.22.78-.48,1.03.78.03,1.4-.58,1.55-1.43,0,0,.06-.38.15-.94.1-.56.24-1.34.42-2.09.34-1.5.81-3.04.81-3.04.31-.98-.24-2.05-1.31-2.29Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m85.46,36.51c-.86-.7-2.18-.54-2.82.26,0,0-1.01,1.28-1.89,2.57-.45.63-.87,1.32-1.17,1.82-.3.5-.5.83-.5.83-.51.87-.23,2.02.51,2.57.37.27.8.35,1.21.27.41-.08.79-.35,1.07-.77,0,0,.21-.32.54-.79.33-.47.78-1.09,1.26-1.71.48-.63.98-1.22,1.36-1.67.39-.45.65-.74.65-.74.7-.77.64-1.95-.22-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m85.46,36.51c-.49-.41-1.13-.52-1.71-.4.11.05.22.12.32.19.89.64.98,1.84.31,2.62,0,0-1.03,1.23-1.94,2.48-.46.62-.89,1.28-1.21,1.76-.31.49-.51.81-.51.81-.23.36-.53.6-.87.74.7.33,1.52.1,2.01-.65,0,0,.21-.32.54-.79.33-.47.78-1.09,1.26-1.71.48-.63.98-1.22,1.36-1.67.39-.45.65-.74.65-.74.7-.77.64-1.95-.22-2.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m87.19,37.49s-.28.27-.7.71c-.42.44-.95,1.03-1.47,1.63-.51.59-1.01,1.19-1.37,1.67-.35.47-.59.78-.59.78-.6.81-.45,1.99.22,2.61.68.64,1.67.52,2.31-.24,0,0,.43-.52.89-1.03.46-.51.94-1.02.94-1.02l1.42-5.64c-.61-.08-1.24.1-1.67.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m88.67,37.18s.08.08.11.11l.08-.33c-.17-.02-.33-.03-.49,0,.1.07.2.14.3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m84.49,44.43c-.26.34-.6.55-.95.63.65.44,1.5.25,2.07-.42,0,0,.43-.52.89-1.03.46-.51.94-1.02.94-1.02l.53-2.09s-.95.95-1.81,1.92c-.43.48-.85.99-1.16,1.37-.3.38-.5.63-.5.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m87.07,43.02c-.58.63-.66,1.57-.31,2.26l.67-2.65-.36.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m76.21,35.98c-.41-.19-.86-.23-1.29-.16l.47,5.8s.36-.78.76-1.56c.2-.4.41-.78.56-1.06.16-.29.27-.48.27-.48.51-.89.21-2.04-.78-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m76.21,35.98c-.41-.19-.86-.23-1.29-.16l.03.34c.89.49,1.18,1.55.72,2.42l-.45.89.18,2.15s.36-.78.76-1.56c.2-.4.41-.78.56-1.06.16-.29.27-.48.27-.48.51-.89.21-2.04-.78-2.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m75.96,44.63c.8.45,1.75.17,2.21-.73,0,0,.18-.35.45-.85.28-.5.66-1.17,1.07-1.83.41-.67.84-1.33,1.18-1.81.34-.48.57-.8.57-.8.61-.84.43-2-.5-2.6-.93-.58-2.22-.32-2.77.56,0,0-.79,1.26-1.48,2.51-.35.62-.67,1.28-.91,1.76-.23.48-.38.81-.38.81l.22,2.72c.1.1.21.19.34.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m80.95,36c-.53-.35-1.18-.38-1.74-.21.12.04.23.09.34.16.95.56,1.17,1.71.59,2.57,0,0-.89,1.33-1.66,2.66-.78,1.37-1.44,2.74-1.44,2.74-.19.38-.47.66-.79.83.73.24,1.52-.05,1.93-.86,0,0,.18-.35.45-.85.28-.5.66-1.17,1.07-1.83.41-.67.84-1.33,1.18-1.81.34-.48.57-.8.57-.8.61-.84.43-2-.5-2.6Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m98.62,41.05c-.6-.91-1.87-1.25-2.76-.66,0,0-.34.22-.84.55-.5.34-1.15.77-1.78,1.25-.64.48-1.25.96-1.7,1.33-.45.37-.74.62-.74.62-.77.68-.87,1.82-.36,2.6.26.39.64.6,1.05.64.41.06.86-.06,1.25-.36,0,0,1.22-.94,2.52-1.78.65-.42,1.33-.85,1.84-1.14.51-.29.86-.48.86-.48.91-.5,1.24-1.63.66-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m98.62,41.05c-.34-.52-.91-.85-1.49-.93.09.09.17.18.24.29.62.91.33,2.05-.57,2.58,0,0-.34.21-.84.52-.5.32-1.15.73-1.79,1.19-.64.45-1.26.92-1.71,1.27-.45.35-.75.59-.75.59-.33.28-.71.42-1.07.43.55.53,1.4.58,2.11.04,0,0,1.22-.94,2.52-1.78.65-.42,1.33-.85,1.84-1.14.51-.29.86-.48.86-.48.91-.5,1.24-1.63.66-2.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m99.94,42.54s-1.46.72-2.81,1.5c-1.37.8-2.65,1.67-2.65,1.67-.83.57-1.08,1.73-.64,2.54.45.8,1.4,1.06,2.27.53,0,0,.58-.35,1.18-.68.6-.33,1.21-.65,1.21-.65l3.18-4.87c-.55-.28-1.19-.33-1.75-.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m101.43,42.73s.05.1.07.15l.19-.28c-.15-.07-.3-.13-.46-.17.08.1.15.2.21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m95.11,48.22c-.36.23-.74.32-1.11.3.49.59,1.33.74,2.1.27,0,0,.58-.35,1.18-.68.6-.33,1.21-.65,1.21-.65l1.18-1.8s-1.2.58-2.34,1.21c-1.15.65-2.23,1.35-2.23,1.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m98.01,47.73c-.76.4-1.13,1.27-1.03,2.04l1.49-2.28-.47.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "m90.03,37.55c-.32-.32-.73-.53-1.16-.58l-1.42,5.64s.15-.16.38-.39c.23-.23.54-.53.85-.83.63-.6,1.29-1.19,1.29-1.19.78-.7.86-1.86.07-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "m90.03,37.55c-.32-.32-.73-.52-1.16-.58l-.08.33c.69.76.61,1.87-.1,2.53,0,0-.18.17-.36.34-.18.17-.36.35-.36.35l-.53,2.09s.15-.16.38-.39c.23-.23.54-.53.85-.83.63-.6,1.29-1.19,1.29-1.19.78-.7.86-1.86.07-2.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "m87,45.63c.6.72,1.6.7,2.32.03,0,0,.28-.26.7-.65.43-.39,1.01-.91,1.61-1.39.6-.49,1.23-.97,1.7-1.33.48-.36.8-.58.8-.58.84-.58,1.07-1.76.37-2.62-.35-.42-.85-.69-1.36-.76-.52-.07-1.05.07-1.46.4,0,0-.28.23-.71.58-.42.34-.97.82-1.51,1.32-.54.49-1.05.99-1.43,1.36-.38.37-.62.63-.62.63l-.67,2.65c.07.12.14.24.23.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m94.52,39.1c-.4-.48-.99-.76-1.58-.78.1.07.19.17.27.26.71.85.54,2.01-.29,2.64,0,0-.31.24-.78.6-.46.36-1.07.87-1.66,1.38-.59.51-1.15,1.04-1.56,1.43-.41.41-.68.68-.68.68-.3.31-.66.49-1.01.53.3.24.67.35,1.04.31.37-.03.74-.19,1.06-.49,0,0,.28-.26.7-.65.43-.39,1.01-.91,1.61-1.39.6-.49,1.23-.97,1.7-1.33.48-.36.8-.58.8-.58.84-.58,1.07-1.76.37-2.62Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "m109.57,49.62c-.27-1.06-1.36-1.78-2.39-1.52,0,0-.39.1-.97.24-.57.15-1.34.37-2.1.61-.75.24-1.49.5-2.03.7-.55.2-.91.35-.91.35-.94.39-1.42,1.45-1.18,2.34.12.45.41.78.78.96s.83.22,1.31.06c0,0,.37-.12.92-.29.56-.18,1.3-.39,2.05-.57.75-.19,1.52-.36,2.11-.48.58-.11.97-.18.97-.18,1.01-.17,1.71-1.14,1.45-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m109.57,49.62c-.16-.6-.58-1.1-1.1-1.37.05.11.1.23.13.35.29,1.07-.36,2.05-1.38,2.26,0,0-.38.09-.96.21-.57.13-1.33.32-2.09.55-.75.22-1.49.45-2.03.64-.54.18-.91.32-.91.32-.4.15-.8.16-1.14.05.17.35.46.6.81.72.34.13.75.15,1.17,0,0,0,.37-.12.92-.29.56-.18,1.3-.39,2.05-.57.75-.19,1.52-.36,2.11-.48.58-.11.97-.18.97-.18,1.01-.17,1.71-1.14,1.45-2.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m110.33,51.46s-1.61.2-3.14.51c-1.56.32-3.05.73-3.05.73-.97.27-1.57,1.28-1.44,2.2.16.91.99,1.45,1.97,1.24,0,0,.67-.15,1.34-.26.67-.12,1.36-.22,1.36-.22l4.59-3.58c-.43-.44-1.01-.7-1.64-.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m111.68,52.12c0,.05.01.11.02.16l.27-.21c-.12-.12-.24-.23-.38-.31.04.12.07.24.09.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m103.94,55.27c-.41.1-.82.07-1.15-.07.28.71,1.02,1.13,1.9.94,0,0,.67-.15,1.34-.26.67-.12,1.36-.22,1.36-.22l1.7-1.33s-.33.04-.82.11c-.49.07-1.13.16-1.78.29-1.3.24-2.54.55-2.54.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m106.84,55.74c-.84.13-1.48.83-1.63,1.6l2.15-1.68-.52.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m102.59,43.52c-.2-.41-.52-.73-.91-.92l-3.18,4.87s.19-.1.48-.25c.29-.15.69-.34,1.08-.52.78-.36,1.6-.7,1.6-.7.96-.4,1.42-1.48.93-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m102.59,43.52c-.2-.41-.52-.73-.91-.92l-.19.28c.41.92-.03,1.96-.92,2.35l-.9.43-1.18,1.8s.19-.1.48-.25c.29-.15.69-.34,1.08-.52.78-.36,1.6-.7,1.6-.7.96-.4,1.42-1.48.93-2.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m97.09,50.18c.17.43.48.74.88.87.4.13.86.11,1.31-.09,0,0,.35-.16.88-.39.53-.22,1.26-.53,1.98-.79,1.45-.53,2.99-.99,2.99-.99.98-.27,1.58-1.32,1.2-2.35-.19-.51-.57-.93-1.03-1.16-.47-.22-1.01-.28-1.5-.1,0,0-.34.12-.86.31-.51.2-1.2.47-1.86.76-.67.29-1.31.58-1.79.82-.48.24-.8.41-.8.41l-1.49,2.28c.02.14.05.28.11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m106.33,46.45c-.22-.58-.67-1.06-1.24-1.25.07.1.13.21.17.33.4,1.03-.15,2.08-1.13,2.4,0,0-.37.12-.93.31-.56.2-1.3.48-2.02.77-1.44.57-2.81,1.27-2.81,1.27-.38.19-.78.24-1.13.16.4.67,1.25.86,2.05.52,0,0,.35-.16.88-.39.53-.22,1.26-.53,1.98-.79,1.45-.53,2.99-.99,2.99-.99.98-.27,1.58-1.32,1.2-2.35Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m117.16,61.28c.05-.54-.13-1.08-.44-1.49-.33-.4-.8-.68-1.32-.73,0,0-1.59-.16-3.18-.18-.79-.02-1.56-.02-2.15,0-.59.03-.98.04-.98.04-1.01.06-1.82.91-1.87,1.83-.08.94.66,1.62,1.65,1.64,0,0,.38,0,.96.02.58.02,1.36.05,2.13.12.77.07,1.55.15,2.14.23.59.07.98.14.98.14,1.01.17,2-.53,2.08-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m117.16,61.28c.05-.62-.18-1.24-.6-1.66.02.12.03.24.01.37-.08,1.11-1.01,1.83-2.04,1.7,0,0-1.56-.21-3.13-.27-.78-.04-1.54-.05-2.12-.05-.58.01-.97.02-.97.02-.43.01-.81-.11-1.1-.32.09.77.77,1.31,1.64,1.33,0,0,.38,0,.96.02.58.02,1.36.05,2.13.12.77.07,1.55.15,2.14.23.59.07.98.14.98.14,1.01.17,1.99-.53,2.08-1.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "m117.29,63.26s-.39-.08-.98-.19c-.59-.11-1.36-.25-2.15-.35-.79-.1-1.57-.18-2.15-.23-.58-.04-.96-.07-.96-.07-1.03-.05-1.89.7-2.07,1.62-.09.46.04.87.31,1.2.25.33.66.55,1.15.61,0,0,.68.08,1.36.18.67.11,1.35.23,1.35.23l5.5-1.89c-.13-.28-.31-.53-.54-.72-.24-.19-.51-.33-.82-.39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m118.35,64.33c0,.05-.02.11-.04.16l.32-.11c-.07-.15-.15-.29-.25-.42,0,.12,0,.25-.03.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m110,64.79c-.43-.04-.8-.2-1.06-.44.03.77.6,1.39,1.48,1.5,0,0,.68.08,1.36.18.67.11,1.35.23,1.35.23l2.04-.7s-.32-.07-.81-.17c-.48-.1-1.13-.21-1.79-.3-1.3-.2-2.57-.31-2.57-.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m112.59,66.18c-.84-.15-1.67.31-2.07.98l2.58-.89-.52-.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m112.54,53.24c-.05-.46-.27-.85-.57-1.17l-4.59,3.58s.86-.13,1.73-.22c.86-.09,1.74-.14,1.74-.14,1.04-.07,1.82-.95,1.68-2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m112.54,53.24c-.05-.46-.27-.85-.57-1.17l-.27.21c.08,1.01-.64,1.83-1.63,1.93l-.99.11-1.7,1.33s.86-.13,1.73-.22c.86-.09,1.74-.14,1.74-.14,1.04-.07,1.82-.94,1.68-2.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "m105.18,57.77c.04.46.22.85.55,1.11.32.26.78.38,1.27.34,0,0,1.51-.15,3.09-.2,1.54-.04,3.14.04,3.14.04,1.04.05,1.92-.74,1.9-1.84,0-1.11-.95-2.03-1.99-2.02,0,0-.36,0-.91.02-.55.02-1.29.06-2,.12-1.43.1-2.85.32-2.85.32l-2.15,1.68c-.03.14-.04.28-.03.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m115.12,57.22c-.01-.63-.3-1.22-.77-1.58.03.12.05.24.06.37.06,1.1-.81,1.93-1.84,1.9,0,0-.39-.01-.99,0-.6,0-1.39.03-2.16.08-.77.04-1.54.11-2.12.18-.57.07-.95.12-.95.12-.43.06-.81-.03-1.12-.21.17.76.9,1.23,1.77,1.15,0,0,1.51-.15,3.09-.2,1.54-.04,3.14.04,3.14.04,1.04.05,1.92-.74,1.9-1.84Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m120.54,74.78c.48-1,0-2.24-.94-2.67,0,0-.36-.17-.92-.4-.56-.24-1.3-.54-2.03-.81-.73-.28-1.48-.53-2.04-.7-.56-.17-.93-.28-.93-.28-.97-.28-2.02.27-2.37,1.12-.35.85.08,1.75,1.03,2.09,0,0,1.43.51,2.87,1.14,1.42.62,2.82,1.37,2.82,1.37.92.49,2.04.15,2.5-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m120.54,74.78c.13-.29.19-.59.19-.89,0-.3-.09-.6-.22-.86-.02.12-.06.24-.11.36-.41,1.02-1.56,1.4-2.47.94,0,0-.35-.18-.9-.42-.54-.25-1.26-.56-1.98-.85-.71-.29-1.45-.56-2-.74-.55-.18-.91-.3-.91-.3-.41-.13-.72-.37-.92-.67-.17.76.28,1.49,1.12,1.79,0,0,1.43.51,2.87,1.14,1.42.62,2.82,1.37,2.82,1.37.92.49,2.04.15,2.5-.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m120.01,76.69s-.34-.2-.86-.5c-.52-.3-1.23-.67-1.94-1.03-.71-.35-1.4-.68-1.94-.92-.54-.23-.9-.38-.9-.38-.94-.38-2.04.04-2.47.85-.48.82-.09,1.75.78,2.19,0,0,.61.3,1.22.62.61.32,1.22.66,1.22.66h5.81c-.08-.61-.4-1.18-.93-1.49Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m120.69,78.04s-.05.09-.08.14h.34c-.02-.16-.06-.33-.11-.48-.04.12-.08.23-.14.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m112.62,75.76c-.39-.17-.68-.45-.85-.76-.26.74.14,1.51.91,1.91,0,0,.61.3,1.22.62.61.32,1.22.66,1.22.66h2.15s-1.16-.69-2.31-1.29c-.58-.3-1.15-.59-1.6-.79-.44-.2-.74-.34-.74-.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m114.63,77.92c-.76-.41-1.69-.25-2.26.26h2.73l-.47-.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "m118.8,65.66c.09-.44.01-.89-.16-1.29l-5.5,1.89s.85.16,1.71.35c.86.19,1.7.43,1.7.43,1,.28,2.03-.3,2.26-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m118.8,65.66c.09-.44.01-.89-.17-1.29l-.32.11c-.26.99-1.21,1.52-2.17,1.3l-.97-.22-2.04.7s.85.16,1.71.35c.86.19,1.7.43,1.7.43,1,.28,2.02-.3,2.26-1.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "m110.36,67.55c-.24.88.26,1.73,1.25,1.96,0,0,.37.09.93.23.55.15,1.3.36,2.04.59.76.23,1.48.5,2.04.7.55.21.92.36.92.36.97.39,2.05-.07,2.4-1.12.36-1.05-.24-2.23-1.22-2.56,0,0-1.42-.46-2.81-.82-.69-.18-1.4-.34-1.93-.45-.53-.1-.88-.17-.88-.17l-2.58.89c-.07.12-.13.25-.17.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m119.94,70.28c.21-.6.09-1.24-.22-1.75-.01.12-.03.24-.07.37-.29,1.06-1.38,1.55-2.35,1.2,0,0-1.51-.54-3-.96-.74-.21-1.51-.39-2.07-.52-.56-.12-.93-.2-.93-.2-.42-.09-.75-.29-1-.56-.06.76.43,1.46,1.31,1.66,0,0,.37.09.93.23.55.15,1.3.36,2.04.59.76.23,1.48.5,2.04.7.55.21.92.36.92.36.97.39,2.05-.07,2.4-1.12Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "17.39 78.14 71.4 84.78 78.45 78.19 70.76 78.1 17.39 78.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "78.36 85.88 78.41 139.24 85.05 85.23 78.45 78.19 78.36 85.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "78.5 17.13 71.85 71.14 78.45 78.19 78.54 70.49 78.5 17.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "78.51 78.19 86.15 78.28 139.51 78.23 85.5 71.59 78.51 78.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m141.39,78l-55.49-6.83-.39-.05c-.17-1.36-6.78-55.61-6.82-55.89-.03-.28-.39-.24-.43.01l-6.83,55.49-.05.38c-1.37.17-55.61,6.78-55.89,6.82-.28.03-.24.39.01.42l55.49,6.83.39.05c.17,1.37,6.78,55.61,6.82,55.89.03.28.39.24.42-.01l6.83-55.49.05-.39c1.37-.17,55.61-6.78,55.89-6.82.28-.03.24-.39-.01-.42Zm-62.98,61.24l-.04-53.36.09-7.7-7.05,6.6-54.01-6.64,53.36-.04,7.7.09-6.6-7.05,6.64-54.01.04,53.36-.09,7.7,6.6,7.05-6.64,54.01Zm7.74-60.97l-7.64-.09,6.99-6.6,54.01,6.64-53.36.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "44.31 112.27 78.2 85.81 78.45 78.19 74.1 82.44 44.31 112.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "82.7 82.54 112.54 112.32 86.07 78.44 78.45 78.19 82.7 82.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "44.37 44.05 70.83 77.93 78.45 78.19 74.2 73.84 44.37 44.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "78.48 78.15 82.8 73.94 112.59 44.1 78.7 70.56 78.48 78.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.49,113.49c.18.14.35-.09.23-.24l-27.18-34.82-.19-.24c.67-.86,27.28-34.86,27.41-35.03.14-.18-.09-.35-.25-.23l-34.82,27.18-.24.19c-.85-.67-34.86-27.28-35.03-27.41-.18-.14-.35.09-.23.24l27.18,34.82.19.24c-.67.86-27.28,34.86-27.41,35.03-.14.18.09.35.24.23l34.82-27.18.24-.19m34.08,26.25l-29.84-29.79-4.25-4.35-.25,7.62-33.89,26.46,29.79-29.84,4.35-4.25-7.62-.25-26.46-33.89,29.84,29.79,4.25,4.35,7.62.25,26.46,33.89Zm-29.74-38.39l-4.32,4.22.22-7.59,33.89-26.46-29.79,29.84Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.8,78.19c0,2.4-1.95,4.35-4.35,4.35s-4.35-1.95-4.35-4.35,1.95-4.35,4.35-4.35,4.35,1.95,4.35,4.35Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaveganteEstelar);
export default __webpack_public_path__ + "static/media/navegante-estelar.bd76e2c1de75186f2cfab8fa464cf741.svg";
export { ForwardRef as ReactComponent };